<!--
 * @Description: 模块编辑器组件
 * @Author: your name
 * @Date: 2023-08-20
 * @LastEditTime: 2025-04-26 15:40:43
-->
<template>
    <div class="schema-module-editor">
        <div class="module-header">
            <span class="header-title">{{ title }}</span>
            <el-button type="primary" size="mini" @click="openModuleDialog">管理模块</el-button>
        </div>
        <!-- 模块列表显示 -->
        <div class="modules-list" v-if="moduleList.length > 0">
            <draggable v-model="moduleList" @change="handleDragChange" handle=".module-item" ghost-class="ghost-module"
                animation="300">
                <div v-for="(module, index) in moduleList" :key="index" class="module-item" @click="editModule(module)">
                    <div class="module-content">
                        <div class="module-icon" v-if="module.icon && module.icon.trim()">
                            <img v-if="isImageUrl(module.icon)" :src="module.icon" alt="图标">
                            <i v-else :class="module.icon"></i>
                        </div>
                        <div class="module-info">
                            <div class="module-title">{{ module.title }}</div>
                            <div class="module-subtitle" v-if="module.subtitle">{{ module.subtitle }}</div>
                            <div class="module-type">{{ getLinkTypeName(module.linkType) }}</div>
                        </div>
                    </div>
                    <div class="module-actions">
                        <i class="el-icon-rank drag-handle" title="拖动排序"></i>
                        <el-button id="module-delete-button" size="mini" type="danger" plain
                            style="padding: 7px 15px; font-size: 12px; margin: 0; font-weight: bold;"
                            class="module-delete-btn" @click.stop="deleteModule(index)"> 删除模块 </el-button>
                    </div>
                </div>
            </draggable>
        </div>
        <div class="empty-tip" v-else>
            <i class="el-icon-document"></i>
            <span>暂无模块，请点击"管理模块"添加</span>
        </div>
        <!-- 模块编辑对话框 -->
        <el-dialog :title="getModuleDialogTitle()" :visible.sync="dialogVisible" width="650px" append-to-body>
            <el-form ref="moduleForm" :model="currentModule" label-width="90px" size="small">
                <!-- 添加模块类型选择 -->
                <el-form-item label="模块类型" required>
                    <el-select v-model="currentModule.linkType" placeholder="请选择模块类型" style="width: 100%"
                        @change="handleLinkTypeChange">
                        <el-option label="活动简介" value="intro"><span>活动简介
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="会场直播" value="live"><span>会场直播
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="新闻资讯" value="news"><span>新闻资讯
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="图片集" value="images"><span>图片集
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="视频集" value="videos"><span>视频集
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="文档集" value="documents"><span>文档集
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="演讲嘉宾" value="speakers"><span>演讲嘉宾
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="会议日程" value="schedule"><span>会议日程
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="合作伙伴" value="partners"><span>合作伙伴
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="个人中心" value="profile"><span>个人中心
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="报名入口" value="register"></el-option>
                        <el-option label="外部链接" value="external"><span>外部链接
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                        <el-option label="站内链接" value="internalLink"><span>站内链接
                                <!--<el-tag size="mini" type="success">可设置报名后进入</el-tag>--></span></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="currentModule.title" placeholder="请输入模块标题"></el-input>
                </el-form-item>
                <!-- 添加显示模式切换 -->
                <el-form-item label="显示模式">
                    <el-radio-group v-model="currentModule.displayMode">
                        <el-radio label="composite">组合模式</el-radio>
                        <el-radio label="image">纯图片模式</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- 纯图片模式下的图片上传 -->
                <el-form-item v-if="currentModule.displayMode === 'image'" label="按钮图片">
                    <div class="icon-input-container">
                        <div class="icon-content">
                            <div class="icon-upload">
                                <div class="upload-preview" v-if="currentModule.buttonImage">
                                    <img :src="currentModule.buttonImage" alt="按钮图片" class="preview-image">
                                    <div class="upload-actions">
                                        <el-button type="danger" size="mini" icon="el-icon-delete" circle
                                            @click="currentModule.buttonImage = ''"></el-button>
                                    </div>
                                </div>
                                <div v-else>
                                    <el-upload action="/api/upload" :show-file-list="false"
                                        :on-success="(res) => handleImageSuccess(res, 'buttonImage')"
                                        :before-upload="beforeImageUpload" :on-error="handleUploadError"
                                        accept="image/*" class="el-upload-btn">
                                        <div class="upload-btn-inner">
                                            <i class="el-icon-plus"></i>
                                            <span>上传图片</span>
                                        </div>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <!-- 组合模式下的配置项 -->
                <template v-if="currentModule.displayMode === 'composite'">
                    <el-form-item label="副标题">
                        <el-input v-model="currentModule.subtitle" placeholder="请输入模块副标题"></el-input>
                    </el-form-item>
                    <el-form-item label="图标">
                        <div class="icon-input-container">
                            <div class="icon-content">
                                <div class="icon-upload">
                                    <div class="upload-preview"
                                        v-if="currentModule.icon && isImageUrl(currentModule.icon)">
                                        <img :src="currentModule.icon" alt="图标">
                                        <div class="upload-actions">
                                            <el-button type="danger" size="mini" icon="el-icon-delete" circle
                                                @click="removeIcon"></el-button>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <FaImageUpload v-model="currentModule.icon" :maxCount="1" accept="image/*"
                                            :width="100" :height="100" :compress="true" :quality="0.8" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="背景颜色">
                        <el-color-picker v-model="currentModule.backgroundColor"></el-color-picker>
                        <span class="color-value">{{ currentModule.backgroundColor }}</span>
                    </el-form-item>
                    <el-form-item label="字体颜色">
                        <el-color-picker v-model="currentModule.fontColor"></el-color-picker>
                        <span class="color-value">{{ currentModule.fontColor }}</span>
                    </el-form-item>
                </template>
                <!-- 添加模块形状选择 -->
                <el-form-item label="布局形状">
                    <div class="shape-selector">
                        <div v-for="(shape, index) in shapeOptions" :key="index" class="shape-item"
                            :class="{ active: currentModule.shape === shape.value }" @click="selectShape(shape.value)">
                            <div class="shape-preview" :class="[shape.value]">
                                <div class="shape-block"></div>
                            </div>
                            <div class="shape-name">{{ shape.label }}</div>
                            <div class="shape-name">{{ shape.text }}</div>
                        </div>
                    </div>
                </el-form-item>
                <!-- 添加报名后进入开关 - 除了报名入口外所有模块都显示这个开关 -->
                <el-form-item v-if="currentModule.linkType && currentModule.linkType !== 'register'" label="报名后进入">
                    <el-switch v-model="currentModule.requiresRegistration" active-color="#13ce66"
                        inactive-color="#ff4949" active-text="是" inactive-text="否">
                    </el-switch>
                    <div class="form-tip" style="margin-top: 5px; font-size: 12px; color: #909399;">
                        开启后，用户需要完成报名才能访问此模块内容 </div>
                </el-form-item>
                <!-- 根据不同模块类型显示不同的配置项 -->
                <template v-if="currentModule.linkType === 'intro'">
                    <el-form-item label="内容">
                        <mc-rich-text v-model="currentModule.content" placeholder="请输入活动简介内容"></mc-rich-text>
                    </el-form-item>
                </template>
                <template v-else-if="currentModule.linkType === 'live'">
                    <!-- 初始化liveConfig对象 -->
                    <div v-if="!currentModule.liveConfig" style="display: none">
                        {{ initializeLiveConfig() }}
                    </div>
                    <el-form-item label="数据来源">
                        <el-select v-model="currentModule.liveConfig.dataSource" placeholder="请选择数据来源"
                            style="width: 100%">
                            <el-option label="选择数据源" value="existing"></el-option>
                            <el-option label="选择动态数据" value="dynamic"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="显示样式">
                        <el-select v-model="currentModule.liveConfig.style" placeholder="请选择显示样式" style="width: 100%">
                            <el-option label="滑动" value="scroll"></el-option>
                            <el-option label="列表" value="list"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="一行显示">
                        <el-select v-model="currentModule.liveConfig.max" placeholder="请选择每行显示数量" style="width: 100%">
                            <el-option label="1个" value="1"></el-option>
                            <el-option label="2个" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- Add buttons for data selection -->
                    <el-form-item v-if="currentModule.liveConfig.dataSource === 'existing'" label="选择直播间">
                        <el-button type="primary" size="small" @click="selectLiveData">选择直播数据</el-button>
                        <div v-if="currentModule.liveConfig.liveList && currentModule.liveConfig.liveList.length"
                            class="selected-items-container"
                            style="margin-top: 15px; width: 100%; max-width: 100%; overflow: hidden;">
                            <div class="selected-items-grid"
                                style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; width: 100%;">
                                <div v-for="(item, index) in currentModule.liveConfig.liveList" :key="item.id"
                                    class="selected-item"
                                    style="width: 100%; max-width: 100%; box-sizing: border-box; overflow: hidden;">
                                    <div class="item-preview-image"
                                        style="width: 100%; height: 120px; overflow: hidden; position: relative;">
                                        <img :src="item.image" :alt="item.title"
                                            style="width: 100%; height: 100%; object-fit: cover; max-height: 120px;">
                                        <el-button class="delete-btn" type="danger" size="mini" icon="el-icon-delete"
                                            circle @click.stop="removeLiveItem(index)"
                                            style="position: absolute; top: 5px; right: 5px; z-index: 10;"></el-button>
                                    </div>
                                    <div class="item-info" style="width: 100%; overflow: hidden;">
                                        <div class="item-title"
                                            style="font-size: 13px; height: 36px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                                            {{ item.title }}
                                        </div>
                                        <div class="item-meta" style="font-size: 12px; color: #909399;">
                                            <span :class="['status-tag', getLiveStatusClass(item.status)]">
                                                {{ getLiveStatusText(item.status) }}
                                            </span>
                                            <div class="item-time" v-if="item.startTime"
                                                style="font-size: 12px; color: #909399; margin-top: 4px;"> 开始：{{
                                                    formatDate(item.startTime) }} </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="currentModule.liveConfig.dataSource === 'dynamic'" label="选择直播分类">
                        <el-button type="primary" size="small" @click="selectLiveCategory">选择直播分类</el-button>
                        <div v-if="currentModule.liveConfig.tabs && currentModule.liveConfig.tabs.length" class="mt-2">
                            已选择 {{ currentModule.liveConfig.tabs.length }} 个分类 </div>
                    </el-form-item>
                </template>
                <template v-else-if="currentModule.linkType === 'news'">
                    <!-- 初始化newsConfig对象 -->
                    <div v-if="!currentModule.newsConfig" style="display: none">
                        {{ initializeNewsConfig() }}
                    </div>
                    <el-form-item label="数据来源">
                        <el-select v-model="currentModule.newsConfig.dataSource" placeholder="请选择数据来源"
                            style="width: 100%">
                            <el-option label="手动选择" value="existing"></el-option>
                            <el-option label="动态加载" value="dynamic"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="currentModule.newsConfig.dataSource === 'existing'" label="选择新闻">
                        <el-button type="primary" size="small" @click="selectNews"> 选择新闻 </el-button>
                        <div v-if="currentModule.newsConfig.newsList && currentModule.newsConfig.newsList.length"
                            class="selected-items-container"
                            style="margin-top: 15px; width: 100%; max-width: 100%; overflow: hidden;">
                            <div class="selected-items-grid"
                                style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; width: 100%;">
                                <div v-for="(item, index) in currentModule.newsConfig.newsList" :key="item.id"
                                    class="selected-item"
                                    style="width: 100%; max-width: 100%; box-sizing: border-box; overflow: hidden;">
                                    <div class="item-preview-image"
                                        style="width: 100%; height: 120px; overflow: hidden; position: relative;">
                                        <img :src="item.cover" :alt="item.title"
                                            style="width: 100%; height: 100%; object-fit: cover; max-height: 120px;">
                                        <el-button class="delete-btn" type="danger" size="mini" icon="el-icon-delete"
                                            circle @click.stop="removeNewsItem(index)"
                                            style="position: absolute; top: 5px; right: 5px; z-index: 10;"></el-button>
                                    </div>
                                    <div class="item-info" style="width: 100%; overflow: hidden;">
                                        <div class="item-title"
                                            style="font-size: 13px; height: 36px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                                            {{ item.title }}
                                        </div>
                                        <div class="item-meta" style="font-size: 12px; color: #909399;">
                                            <span class="item-date">{{ formatDate(item.publishTime) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="currentModule.newsConfig.dataSource === 'dynamic'" label="选择新闻分类">
                        <el-button type="primary" size="small" @click="selectNewsCategory"> 选择新闻分类 </el-button>
                        <div v-if="currentModule?.newsConfig?.tabs && currentModule.newsConfig.tabs.length > 0"
                            class="selected-categories">
                            <div class="selected-count">已选择 {{ currentModule.newsConfig.tabs.length }} 个子分类</div>
                            <div class="selected-tags">
                                <el-tag v-for="(tag, index) in currentModule.newsConfig.tabs" :key="index" size="small"
                                    class="subcategory-tag" effect="plain">
                                    {{ tag.name }}
                                </el-tag>
                            </div>
                        </div>
                        <div v-else class="no-selection">未选择任何分类</div>
                    </el-form-item>
                    <el-form-item label="一行显示">
                        <el-select v-model="currentModule.newsConfig.max" placeholder="请选择每行显示数量" style="width: 100%">
                            <el-option label="1个" value="1"></el-option>
                            <el-option label="2个" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 展示已选择的新闻 - 移到表单末尾 -->
                    <el-form-item
                        v-if="currentModule.newsConfig.dataSource === 'existing' && currentModule.newsConfig.newsList && currentModule.newsConfig.newsList.length"
                        label="已选新闻">
                        <div class="selected-news-container">
                            <div class="selected-count">已选择 {{ currentModule.newsConfig.newsList.length }} 个新闻</div>
                        </div>
                    </el-form-item>
                </template>
                <template v-else-if="currentModule.linkType === 'images'">
                    <!-- 初始化imagesConfig对象 -->
                    <div v-if="!currentModule.imagesConfig" style="display: none">
                        {{ initializeImagesConfig() }}
                    </div>
                    <el-form-item label="数据来源">
                        <el-select v-model="currentModule.imagesConfig.dataSource" placeholder="请选择数据来源"
                            style="width: 100%">
                            <el-option label="手动选择" value="existing"></el-option>
                            <el-option label="动态加载" value="dynamic"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="一行显示">
                        <el-select v-model="currentModule.imagesConfig.columns" placeholder="请选择一行显示个数"
                            style="width: 100%">
                            <el-option label="一个" :value="1"></el-option>
                            <el-option label="两个" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="currentModule.imagesConfig.style === 'slide'" label="滑动设置">
                        <el-checkbox v-model="currentModule.imagesConfig.autoplay">自动播放</el-checkbox>
                        <el-input-number v-if="currentModule.imagesConfig.autoplay"
                            v-model="currentModule.imagesConfig.interval" :min="1000" :max="10000" :step="500"
                            style="margin-left: 10px;" size="small">
                        </el-input-number>
                        <span v-if="currentModule.imagesConfig.autoplay" style="margin-left: 5px;">ms</span>
                    </el-form-item>
                    <!-- 手动选择图片 -->
                    <el-form-item v-if="currentModule.imagesConfig.dataSource === 'existing'" label="选择图片">
                        <el-button type="primary" size="small" @click="selectImages">选择图片</el-button>
                        <div v-if="currentModule.imagesConfig.imageList && currentModule.imagesConfig.imageList.length"
                            class="selected-items-container"
                            style="margin-top: 15px; width: 100%; max-width: 100%; overflow: hidden;">
                            <div class="selected-items-grid"
                                style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; width: 100%;">
                                <div v-for="(item, index) in currentModule.imagesConfig.imageList"
                                    :key="item.id || index" class="selected-item"
                                    style="width: 100%; max-width: 100%; box-sizing: border-box; overflow: hidden;">
                                    <div class="item-preview-image"
                                        style="width: 100%; height: 120px; overflow: hidden; position: relative;">
                                        <img :src="item.url || item.content || item.cover || item.path"
                                            :alt="item.title"
                                            style="width: 100%; height: 100%; object-fit: cover; max-height: 120px;">
                                        <el-button class="delete-btn" type="danger" size="mini" icon="el-icon-delete"
                                            circle @click.stop="removeImageItem(index)"
                                            style="position: absolute; top: 5px; right: 5px; z-index: 10;"></el-button>
                                    </div>
                                    <div class="item-info" style="width: 100%; overflow: hidden;">
                                        <div class="item-title"
                                            style="font-size: 13px; height: 36px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                                            {{ item.title || '图片' }}
                                        </div>
                                        <div class="item-meta" style="font-size: 12px; color: #909399;">
                                            <span class="item-date">{{ formatDate(item.publishTime) }}</span>
                                        </div>
                                        <!-- 修改链接输入部分 -->
                                        <div class="item-link" style="margin-top: 8px;">
                                            <el-form-item label-width="0px">
                                                <el-select v-model="item.linkTargetType" placeholder="链接类型" size="mini"
                                                    style="width: 100%; margin-bottom: 5px;"
                                                    @change="handleImageLinkTypeChange(item)">
                                                    <el-option label="外部链接" value="external"></el-option>
                                                    <el-option label="站内页面" value="internal"></el-option>
                                                </el-select>
                                                <el-input
                                                    v-if="item.linkTargetType === 'external' || !item.linkTargetType"
                                                    v-model="item.linkUrl" placeholder="请输入跳转链接 (例: https://...)"
                                                    size="mini" clearable>
                                                    <template slot="prepend">链接</template>
                                                </el-input>
                                                <el-select v-if="item.linkTargetType === 'internal'"
                                                    v-model="item.internalPageId" placeholder="请选择站内页面" size="mini"
                                                    style="width: 100%;" clearable filterable
                                                    @change="(pageId) => handleInternalPageSelect(item, pageId)">
                                                    <el-option v-for="page in availableSitePages" :key="page.id"
                                                        :label="page.name" :value="page.id">
                                                    </el-option>
                                                    <template slot="empty">
                                                        <div style="text-align: center; padding: 10px;">
                                                            <i class="el-icon-document"
                                                                style="font-size: 18px; color: #dcdfe6;"></i>
                                                            <p style="margin: 5px 0 0; color: #909399;">当前微站暂无页面</p>
                                                        </div>
                                                    </template>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <!-- 动态数据源 - 选择分类 -->
                    <el-form-item v-if="currentModule.imagesConfig.dataSource === 'dynamic'" label="选择图片分类">
                        <el-button type="primary" size="small" @click="selectImageCategory"> 选择图片分类 </el-button>
                        <div v-if="currentModule?.imagesConfig?.tabs && currentModule.imagesConfig.tabs.length > 0"
                            class="selected-categories">
                            <div class="selected-count">已选择 {{ currentModule.imagesConfig.tabs.length }} 个子分类</div>
                            <div class="selected-tags">
                                <el-tag v-for="(tag, index) in currentModule.imagesConfig.tabs" :key="index"
                                    size="small" class="subcategory-tag" effect="plain">
                                    {{ tag.name }}
                                </el-tag>
                            </div>
                        </div>
                        <div v-else class="no-selection">未选择任何分类</div>
                    </el-form-item>
                    <!-- 展示已选择的图片 - 移到表单末尾 -->
                    <el-form-item
                        v-if="currentModule.imagesConfig.dataSource === 'existing' && currentModule.imagesConfig.imageList && currentModule.imagesConfig.imageList.length"
                        label="已选图片">
                        <div class="selected-images-container">
                            <div class="selected-count">已选择 {{ currentModule.imagesConfig.imageList.length }} 个图片</div>
                        </div>
                    </el-form-item>
                </template>
                <template v-else-if="currentModule.linkType === 'videos'">
                    <!-- 初始化videosConfig对象 -->
                    <div v-if="!currentModule.videosConfig" style="display: none">
                        {{ initializeVideosConfig() }}
                    </div>
                    <el-form-item label="数据来源">
                        <el-select v-model="currentModule.videosConfig.dataSource" placeholder="请选择数据来源"
                            style="width: 100%">
                            <el-option label="手动选择" value="existing"></el-option>
                            <el-option label="动态加载" value="dynamic"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="一行显示">
                        <el-select v-model="currentModule.videosConfig.columns" placeholder="请选择一行显示个数"
                            style="width: 100%">
                            <el-option label="一个" :value="1"></el-option>
                            <el-option label="两个" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="控制栏开关">
                        <el-switch v-model="currentModule.videosConfig.showControls"></el-switch>
                    </el-form-item>
                    <el-form-item label="播放模式">
                        <el-select v-model="currentModule.videosConfig.playMode" placeholder="请选择播放模式"
                            style="width: 100%">
                            <el-option label="不自动播放" value="default"></el-option>
                            <el-option label="自动播放" value="auto"></el-option>
                            <el-option label="自动播放并静音" value="auto_muted"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="视频信息开关">
                        <el-switch v-model="currentModule.videosConfig.showInfo"></el-switch>
                    </el-form-item>
                    <el-form-item label="视频循环开关">
                        <el-switch v-model="currentModule.videosConfig.loop"></el-switch>
                    </el-form-item>
                    <!-- 手动选择视频 -->
                    <el-form-item v-if="currentModule.videosConfig.dataSource === 'existing'" label="选择视频">
                        <el-button type="primary" size="small" @click="selectVideos">选择视频</el-button>
                        <div v-if="currentModule.videosConfig.videoList && currentModule.videosConfig.videoList.length"
                            class="selected-items-container"
                            style="margin-top: 15px; width: 100%; max-width: 100%; overflow: hidden;">
                            <div class="selected-items-grid"
                                style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; width: 100%;">
                                <div v-for="(item, index) in currentModule.videosConfig.videoList" :key="item.id"
                                    class="selected-item"
                                    style="width: 100%; max-width: 100%; box-sizing: border-box; overflow: hidden;">
                                    <div class="item-preview-image"
                                        style="width: 100%; height: 120px; overflow: hidden; position: relative;">
                                        <img :src="item.poster || item.cover" :alt="item.title"
                                            style="width: 100%; height: 100%; object-fit: cover; max-height: 120px;">
                                        <el-button class="delete-btn" type="danger" size="mini" icon="el-icon-delete"
                                            circle @click.stop="removeVideoItem(index)"
                                            style="position: absolute; top: 5px; right: 5px; z-index: 10;"></el-button>
                                    </div>
                                    <div class="item-info" style="width: 100%; overflow: hidden;">
                                        <div class="item-title"
                                            style="font-size: 13px; height: 36px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                                            {{ item.title }}
                                        </div>
                                        <div class="item-meta" style="font-size: 12px; color: #909399;">
                                            <span class="item-date">{{ formatDate(item.publishTime) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="currentModule.videosConfig.dataSource === 'dynamic'" label="选择视频分类">
                        <el-button type="primary" size="small" @click="selectVideoCategory"> 选择视频分类 </el-button>
                        <div v-if="currentModule?.videosConfig?.tabs && currentModule.videosConfig.tabs.length > 0"
                            class="selected-categories">
                            <div class="selected-count">已选择 {{ currentModule.videosConfig.tabs.length }} 个子分类</div>
                            <div class="selected-tags">
                                <el-tag v-for="(tag, index) in currentModule.videosConfig.tabs" :key="index"
                                    size="small" class="subcategory-tag" effect="plain">
                                    {{ tag.name }}
                                </el-tag>
                            </div>
                        </div>
                        <div v-else class="no-selection">未选择任何分类</div>
                    </el-form-item>
                    <!-- 展示已选择的视频 - 移到表单末尾 -->
                    <el-form-item
                        v-if="currentModule.videosConfig.dataSource === 'existing' && currentModule.videosConfig.videoList && currentModule.videosConfig.videoList.length"
                        label="已选视频">
                        <div class="selected-videos-container">
                            <div class="selected-count">已选择 {{ currentModule.videosConfig.videoList.length }} 个视频</div>
                        </div>
                    </el-form-item>
                </template>
                <template v-else-if="currentModule.linkType === 'documents'">
                    <!-- 初始化documentsConfig对象 -->
                    <div v-if="!currentModule.documentsConfig" style="display: none">
                        {{ initializeDocumentsConfig() }}
                    </div>
                    <el-form-item label="数据来源">
                        <el-select v-model="currentModule.documentsConfig.dataSource" placeholder="请选择数据来源"
                            style="width: 100%">
                            <el-option label="手动选择" value="existing"></el-option>
                            <el-option label="动态加载" value="dynamic"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="一行显示">
                        <el-select v-model="currentModule.documentsConfig.columns" placeholder="请选择一行显示个数"
                            style="width: 100%">
                            <el-option label="一个" :value="1"></el-option>
                            <el-option label="两个" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 动态数据源 - 分类选择 -->
                    <template v-if="currentModule.documentsConfig.dataSource === 'dynamic'">
                        <el-form-item label="文档分类">
                            <div v-if="currentModule.documentsConfig.tabs && currentModule.documentsConfig.tabs.length > 0"
                                class="selected-categories">
                                <el-tag v-for="tab in currentModule.documentsConfig.tabs" :key="tab._id" closable
                                    @close="removeDocumentTab(tab._id)">
                                    {{ tab.name }}
                                </el-tag>
                            </div>
                            <el-button type="primary" size="mini" @click="selectDocumentCategory">选择文档分类</el-button>
                            <div class="tip-text"> 选择文档分类后，将根据分类自动加载文档 </div>
                        </el-form-item>
                    </template>
                    <!-- 手动选择 - 文档列表 -->
                    <template v-else>
                        <el-form-item label="文档列表">
                            <el-button type="primary" size="mini" @click="selectDocuments">选择文档</el-button>
                            <div class="tip-text"
                                v-if="currentModule.documentsConfig.documentList && currentModule.documentsConfig.documentList.length === 0">
                                暂未选择任何文档，请点击"选择文档"按钮添加 </div>
                        </el-form-item>
                        <!-- 已选择的文档列表 -->
                        <el-form-item
                            v-if="currentModule.documentsConfig.documentList && currentModule.documentsConfig.documentList.length > 0"
                            label="已选文档">
                            <div class="selected-documents-container">
                                <div class="selected-count">已选择 {{ currentModule.documentsConfig.documentList.length }}
                                    个文档</div>
                                <el-table :data="currentModule.documentsConfig.documentList" style="width: 100%">
                                    <el-table-column prop="title" label="标题" min-width="150"></el-table-column>
                                    <el-table-column label="操作" width="100">
                                        <template #default="scope">
                                            <el-button type="danger" size="mini"
                                                @click="removeDocumentItem(scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form-item>
                    </template>
                </template>
                <template v-else-if="currentModule.linkType === 'partners'">
                    <!-- 初始化partnersConfig对象 -->
                    <div v-if="!currentModule.partnersConfig" style="display: none">
                        {{ initializePartnersConfig() }}
                    </div>
                    <el-form-item label="数据来源">
                        <el-select v-model="currentModule.partnersConfig.dataSource" placeholder="请选择数据来源"
                            style="width: 100%">
                            <el-option label="手动选择" value="existing"></el-option>
                            <el-option label="动态加载" value="dynamic"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="一行显示">
                        <el-select v-model="currentModule.partnersConfig.columns" placeholder="请选择一行显示个数"
                            style="width: 100%">
                            <el-option label="一个" :value="1"></el-option>
                            <el-option label="两个" :value="2"></el-option>
                            <el-option label="三个" :value="3"></el-option>
                            <el-option label="四个" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 手动选择合作伙伴 -->
                    <el-form-item v-if="currentModule.partnersConfig.dataSource === 'existing'" label="选择合作伙伴">
                        <el-button type="primary" size="small" @click="selectPartners">选择合作伙伴</el-button>
                        <div v-if="currentModule.partnersConfig.partnerList && currentModule.partnersConfig.partnerList.length"
                            class="selected-items-container"
                            style="margin-top: 15px; width: 100%; max-width: 100%; overflow: hidden;">
                            <div class="selected-items-grid"
                                style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; width: 100%;">
                                <div v-for="(item, index) in currentModule.partnersConfig.partnerList"
                                    :key="item.id || index" class="selected-item"
                                    style="width: 100%; max-width: 100%; box-sizing: border-box; overflow: hidden;">
                                    <div class="item-preview-image"
                                        style="width: 100%; height: 120px; overflow: hidden; position: relative;">
                                        <img :src="item.url || item.content || item.cover || item.path"
                                            :alt="item.title"
                                            style="width: 100%; height: 100%; object-fit: contain; max-height: 120px;">
                                        <el-button class="delete-btn" type="danger" size="mini" icon="el-icon-delete"
                                            circle @click.stop="removePartnerItem(index)"
                                            style="position: absolute; top: 5px; right: 5px; z-index: 10;"></el-button>
                                    </div>
                                    <div class="item-info" style="width: 100%; overflow: hidden;">
                                        <div class="item-title"
                                            style="font-size: 13px; height: 36px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                                            {{ item.title || '合作伙伴' }}
                                        </div>
                                        <div class="item-meta" style="font-size: 12px; color: #909399;">
                                            <span class="item-date">{{ formatDate(item.publishTime) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <!-- 动态加载合作伙伴 -->
                    <el-form-item v-if="currentModule.partnersConfig.dataSource === 'dynamic'" label="选择分类">
                        <el-button type="primary" size="small" @click="selectPartnerCategories">选择合作伙伴分类</el-button>
                        <div v-if="currentModule?.partnersConfig?.tabs && currentModule.partnersConfig.tabs.length > 0"
                            class="selected-categories">
                            <div class="selected-count">已选择 {{ currentModule.partnersConfig.tabs.length }} 个子分类</div>
                            <div class="categories-tags">
                                <el-tag v-for="(tag, index) in currentModule.partnersConfig.tabs" :key="tag._id"
                                    closable @close="removePartnerTab(index)">
                                    {{ tag.name }}
                                </el-tag>
                            </div>
                        </div>
                    </el-form-item>
                    <!-- 已选择的合作伙伴摘要显示 -->
                    <el-form-item
                        v-if="currentModule.partnersConfig.dataSource === 'existing' && currentModule.partnersConfig.partnerList && currentModule.partnersConfig.partnerList.length"
                        label="已选合作伙伴">
                        <div class="selected-summary">
                            <div class="selected-count">已选择 {{ currentModule.partnersConfig.partnerList.length }} 个合作伙伴
                            </div>
                        </div>
                    </el-form-item>
                </template>
                <template v-else-if="currentModule.linkType === 'external'">
                    <el-form-item label="外部链接" required>
                        <el-input v-model="currentModule.linkUrl" placeholder="请输入HTTPS链接" type="url">
                            <template #prepend>https://</template>
                        </el-input>
                        <div class="form-tip">请输入完整的站外链接地址，必须以https://开头</div>
                    </el-form-item>
                    <el-form-item label="链接打开方式">
                        <el-radio-group v-model="currentModule.openType" size="medium">
                            <el-radio label="_self">当前窗口</el-radio>
                            <el-radio label="_blank">新窗口</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="链接描述">
                        <el-input v-model="currentModule.linkDescription" type="textarea" :rows="3"
                            placeholder="请输入链接描述（可选）"></el-input>
                    </el-form-item>
                </template>
                <template v-else-if="currentModule.linkType === 'speakers'">
                    <!-- 初始化speakersConfig对象 -->
                    <div v-if="!currentModule.speakersConfig" style="display: none">
                        {{ initializeSpeakersConfig() }}
                    </div>
                    <!-- 选择归档（用于前端嘉宾行程查询），复用日程的归档选择逻辑 -->
                    <el-form-item label="选择归档">
                        <el-select v-model="currentModule.speakersConfig.archiveId" placeholder="请选择归档" style="width: 100%" filterable @visible-change="val => val && getArchiveOptions()">
                            <el-option v-for="item in archiveOptions" :key="item._id" :label="item.name" :value="item._id"></el-option>
                        </el-select>
                        <div v-if="currentModule.speakersConfig.archiveId" class="archive-info">
                            <div class="archive-name">已选择归档: {{ getArchiveName(currentModule.speakersConfig.archiveId) }}</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="数据来源">
                        <el-select v-model="currentModule.speakersConfig.dataSource" placeholder="请选择数据来源"
                            style="width: 100%">
                            <el-option label="选择数据源" value="existing"></el-option>
                            <el-option label="选择动态数据" value="dynamic"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="显示样式">
            <el-select v-model="currentModule.speakersConfig.style" placeholder="请选择显示样式" style="width: 100%">
              <el-option label="网格" value="grid"></el-option>
              <el-option label="列表" value="list"></el-option>
            </el-select>
          </el-form-item> -->
                    <!-- <el-form-item label="一行显示">
            <el-select v-model="currentModule.speakersConfig.max" placeholder="请选择每行显示数量" style="width: 100%">
              <el-option label="1个" value="1"></el-option>
              <el-option label="2个" value="2"></el-option>
              <el-option label="3个" value="3"></el-option>
              <el-option label="4个" value="4"></el-option>
            </el-select>
          </el-form-item> -->
                    <!-- 添加按钮用于数据选择 -->
                    <el-form-item v-if="currentModule.speakersConfig.dataSource === 'existing'" label="选择嘉宾">
                        <el-button type="primary" size="small" @click="selectGuestData">选择嘉宾数据</el-button>
                        <div v-if="currentModule.speakersConfig.guestList && currentModule.speakersConfig.guestList.length"
                            class="selected-items-container"
                            style="margin-top: 15px; width: 100%; max-width: 100%; overflow: hidden;">
                            <div class="selected-items-grid"
                                style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; width: 100%;">
                                <div v-for="(item, index) in currentModule.speakersConfig.guestList" :key="item.id"
                                    class="selected-item"
                                    style="width: 100%; max-width: 100%; box-sizing: border-box; overflow: hidden;">
                                    <div class="item-preview-image"
                                        style="width: 100%; height: 120px; overflow: hidden; position: relative;">
                                        <img :src="processImageUrl(item.avatar)" :alt="item.name"
                                            style="width: 100%; height: 100%; object-fit: cover; max-height: 120px;">
                                        <el-button class="delete-btn" type="danger" size="mini" icon="el-icon-delete"
                                            circle @click.stop="removeGuestItem(index)"
                                            style="position: absolute; top: 5px; right: 5px; z-index: 10;"></el-button>
                                    </div>
                                    <div class="item-info" style="width: 100%; overflow: hidden;">
                                        <div class="item-title"
                                            style="font-size: 13px; font-weight: bold; margin-top: 5px;">{{ item.name }}
                                        </div>
                                        <div class="item-meta" style="font-size: 12px; color: #909399;">
                                            <div style="margin-top: 4px;">{{ item.position }}</div>
                                            <div style="margin-top: 2px;">{{ item.company }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>

                    <!-- 新增：隐藏嘉宾头像开关 -->
                    <el-form-item label="隐藏嘉宾头像">
                        <el-switch v-model="currentModule.speakersConfig.hideAvatar" active-text="隐藏" inactive-text="显示"></el-switch>
                    </el-form-item>
                    <el-form-item v-if="currentModule.speakersConfig.dataSource === 'dynamic'" label="选择嘉宾分组">
                        <el-button type="primary" size="small" @click="selectGuestCategory">选择嘉宾分组</el-button>
                        <div v-if="currentModule.speakersConfig.tabs && currentModule.speakersConfig.tabs.length"
                            class="mt-2">
                            <div>已选择 {{ currentModule.speakersConfig.tabs.length }} 个分组</div>
                            <div class="selected-categories">
                                <el-tag v-for="category in currentModule.speakersConfig.tabs" :key="category._id"
                                    type="success" size="small" class="m-1">
                                    {{ category.name }}
                                </el-tag>
                            </div>
                        </div>
                    </el-form-item>
                </template>
                <template v-else-if="currentModule.linkType === 'schedule'">
                    <!-- 初始化scheduleConfig对象 -->
                    <div v-if="!currentModule.scheduleConfig" style="display: none">
                        {{ initializeScheduleConfig() }}
                    </div>
                    <!-- <el-form-item label="显示模式">
            <el-select v-model="currentModule.scheduleConfig.viewMode" placeholder="请选择显示模式" style="width: 100%">
              <el-option label="矩阵视图" value="matrix"></el-option>
              <el-option label="列表视图" value="list"></el-option>
            </el-select>
          </el-form-item> -->
                    <el-form-item label="选择归档">
                        <el-select v-model="currentModule.scheduleConfig.archiveId" placeholder="请选择归档"
                            style="width: 100%" filterable @change="handleArchiveChange">
                            <el-option v-for="item in archiveOptions" :key="item._id" :label="item.name"
                                :value="item._id"></el-option>
                        </el-select>
                        <div v-if="currentModule.scheduleConfig.archiveId" class="archive-info">
                            <div class="archive-name">已选择归档:
                                {{ getArchiveName(currentModule.scheduleConfig.archiveId) }}</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="自动刷新">
                        <el-switch v-model="currentModule.scheduleConfig.autoRefresh"></el-switch>
                        <span class="form-tip" style="margin-left: 10px; font-size: 12px; color: #909399;">
                            启用后将定期自动刷新日程数据 </span>
                    </el-form-item>
                    <el-form-item label="空状态提示" v-if="currentModule.scheduleConfig.viewMode === 'matrix'">
                        <el-input v-model="currentModule.scheduleConfig.emptyText" placeholder="请输入空状态提示文字"></el-input>
                    </el-form-item>
                    <!-- 添加模块类型选择 -->
                </template>
                <el-form-item label="跳转页面" v-if="currentModule.linkType == 'internalLink'">
                    <el-select v-model="currentModule.internalLink" placeholder="请选择跳转页面" style="width: 100%"
                        @change="handleLinkTypeChange">
                        <el-option v-for="item in availableSitePages" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveModule">确 定</el-button>
                </div>
            </template>
        </el-dialog>
        <!-- 新增模块对话框 -->
        <el-dialog title="添加模块" :visible.sync="addDialogVisible" width="500px" append-to-body>
            <el-form ref="addModuleForm" :model="newModule" label-width="80px" size="small">
                <el-form-item label="标题" required>
                    <el-input v-model="newModule.title" placeholder="请输入模块标题"></el-input>
                </el-form-item>
                <el-form-item label="副标题">
                    <el-input v-model="newModule.subtitle" placeholder="请输入模块副标题"></el-input>
                </el-form-item>
                <el-form-item label="链接类型" required>
                    <el-select v-model="newModule.linkType" placeholder="请选择链接类型" style="width: 100%">
                        <el-option label="活动简介" value="intro"></el-option>
                        <el-option label="会场直播" value="live"></el-option>
                        <el-option label="新闻资讯" value="news"></el-option>
                        <el-option label="图片集" value="images"></el-option>
                        <el-option label="视频集" value="videos"></el-option>
                        <el-option label="文档中心" value="documents"></el-option>
                        <el-option label="个人中心" value="profile"></el-option>
                        <el-option label="演讲嘉宾" value="speakers"></el-option>
                        <el-option label="会议日程" value="schedule"></el-option>
                        <el-option label="报名入口" value="register"></el-option>
                        <el-option label="合作伙伴" value="partners"></el-option>
                        <el-option label="站外链接" value="external"></el-option>
                        <el-option label="站内链接" value="internalLink"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addNewModule">确 定</el-button>
                </div>
            </template>
        </el-dialog>
        <!-- 模块类型选择对话框 -->
        <el-dialog title="选择模块类型" :visible.sync="typeDialogVisible" width="650px" append-to-body
            custom-class="module-type-dialog">
            <module-type-selector @select="handleModuleTypeSelect"></module-type-selector>
        </el-dialog>
        <!-- 添加直播选择对话框 -->
        <el-dialog title="选择直播数据" :visible.sync="liveSelectDialogVisible" width="1000px" append-to-body
            custom-class="live-select-dialog">
            <live-list v-if="liveSelectDialogVisible" @onChangeSelection="handleLiveSelection"></live-list>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="liveSelectDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmLiveSelection">确 定</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 添加直播分类选择对话框 -->
        <el-dialog title="选择直播分类" :visible.sync="liveCategoryDialogVisible" width="1000px" append-to-body
            custom-class="live-category-dialog">
            <live-type-list v-if="liveCategoryDialogVisible" ref="liveTypeListRef"></live-type-list>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="liveCategoryDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmCategorySelection">确 定</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 添加新闻选择对话框 -->
        <el-dialog title="选择新闻数据" :visible.sync="newsSelectDialogVisible" width="1000px" append-to-body
            custom-class="news-select-dialog">
            <article-list v-if="newsSelectDialogVisible" @onChangeSelection="handleNewsSelection"></article-list>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="newsSelectDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmNewsDataSelection">确 定</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 分类弹窗 -->
        <el-dialog title="选择新闻分类" :visible.sync="newsCategoryDialogVisible" width="500px" append-to-body>
            <div v-if="newsSubcategories.length > 0" class="subcategory-selection">
                <div class="subcategory-header">
                    <span>新闻子分类</span>
                    <div class="subcategory-controls">
                        <el-button type="text" size="small"
                            @click="selectedNewsSubcategories = newsSubcategories.map(sub => sub._id)"> 全选 </el-button>
                        <el-button type="text" size="small" @click="selectedNewsSubcategories = []"> 清空 </el-button>
                        <span class="selected-count">已选择: {{ selectedNewsSubcategories.length }} 个</span>
                    </div>
                </div>
                <el-divider></el-divider>
                <el-checkbox-group v-model="selectedNewsSubcategories" class="subcategory-list">
                    <el-checkbox v-for="subcategory in newsSubcategories" :key="subcategory._id"
                        :label="subcategory._id" border>
                        {{ subcategory.name }}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <div v-else class="no-subcategories">
                <el-empty description="未找到分类数据"></el-empty>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="newsCategoryDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmNewsSubcategorySelection">确定</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 添加素材对话框 -->
        <material-dialog v-if="materialDialogVisible" :visible.sync="materialDialogVisible"
            :dialog-data="materialDialogData" @select="handleMaterialSelected" />
        <!-- 图片分类选择对话框 -->
        <el-dialog title="选择图片分类" :visible.sync="imageCategoryDialogVisible" width="500px" append-to-body>
            <div v-if="imageSubcategories.length > 0" class="subcategory-selection">
                <div class="subcategory-header">
                    <span>图片子分类</span>
                    <div class="subcategory-controls">
                        <el-button type="text" size="small"
                            @click="selectedImageSubcategories = imageSubcategories.map(sub => sub._id)"> 全选
                        </el-button>
                        <el-button type="text" size="small" @click="selectedImageSubcategories = []"> 清空 </el-button>
                        <span class="selected-count">已选择: {{ selectedImageSubcategories.length }} 个</span>
                    </div>
                </div>
                <el-divider></el-divider>
                <el-checkbox-group v-model="selectedImageSubcategories" class="subcategory-list">
                    <el-checkbox v-for="subcategory in imageSubcategories" :key="subcategory._id"
                        :label="subcategory._id" border>
                        {{ subcategory.name }}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <div v-else class="no-subcategories">
                <el-empty description="未找到分类数据"></el-empty>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="imageCategoryDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmImageSubcategorySelection">确定</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 分类选择对话框 - 视频分类 -->
        <el-dialog title="选择视频分类" :visible.sync="videoCategoryDialogVisible" width="50%" :close-on-click-modal="false"
            :append-to-body="true">
            <el-checkbox-group v-model="selectedVideoSubcategories">
                <el-checkbox v-for="category in videoSubcategories" :key="category._id" :label="category._id">
                    {{ category.name }}
                </el-checkbox>
            </el-checkbox-group>
            <div style="margin-top: 20px;">
                <el-button @click="videoCategoryDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmVideoSubcategorySelection">确认</el-button>
            </div>
        </el-dialog>
        <!-- 新闻分类选择对话框 -->
        <el-dialog title="选择新闻分类" :visible.sync="newsCategoryDialogVisible" width="500px">
            <el-checkbox-group v-model="selectedNewsSubcategories">
                <el-checkbox v-for="subcategory in newsSubcategories" :key="subcategory._id" :label="subcategory._id">
                    {{ subcategory.name }}
                </el-checkbox>
            </el-checkbox-group>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="newsCategoryDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmNewsSubcategorySelection">确 定</el-button>
                </div>
            </template>
        </el-dialog>
        <!-- 文档分类选择对话框 -->
        <el-dialog title="选择文档分类" :visible.sync="documentCategoryDialogVisible" width="500px">
            <el-checkbox-group v-model="selectedDocumentSubcategories">
                <el-checkbox v-for="subcategory in documentSubcategories" :key="subcategory._id"
                    :label="subcategory._id">
                    {{ subcategory.name }}
                </el-checkbox>
            </el-checkbox-group>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="documentCategoryDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmDocumentSubcategorySelection">确 定</el-button>
                </div>
            </template>
        </el-dialog>
        <!-- 合作伙伴分类选择对话框 -->
        <el-dialog title="选择合作伙伴分类" :visible.sync="partnerCategoryDialogVisible" width="500px" append-to-body>
            <div v-if="partnerSubcategories.length > 0" class="subcategory-selection">
                <div class="subcategory-header">
                    <span>合作伙伴子分类</span>
                    <div class="subcategory-controls">
                        <el-button type="text" size="small"
                            @click="selectedPartnerSubcategories = partnerSubcategories.map(sub => sub._id)"> 全选
                        </el-button>
                        <el-button type="text" size="small" @click="selectedPartnerSubcategories = []"> 清空 </el-button>
                        <span class="selected-count">已选择: {{ selectedPartnerSubcategories.length }} 个</span>
                    </div>
                </div>
                <el-divider></el-divider>
                <el-checkbox-group v-model="selectedPartnerSubcategories" class="subcategory-list">
                    <el-checkbox v-for="subcategory in partnerSubcategories" :key="subcategory._id"
                        :label="subcategory._id" border>
                        {{ subcategory.name }}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <div v-else class="no-subcategories">
                <el-empty description="未找到分类数据"></el-empty>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="partnerCategoryDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmPartnerSubcategorySelection">确定</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 嘉宾选择对话框 -->
        <el-dialog title="选择嘉宾数据" :visible.sync="guestSelectDialogVisible" width="1000px" append-to-body
            custom-class="guest-select-dialog">
            <guest-list v-if="guestSelectDialogVisible" @onChangeSelection="handleGuestSelection"></guest-list>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="guestSelectDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmGuestSelection">确定</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 嘉宾分类选择对话框 -->
        <el-dialog title="选择嘉宾分类" :visible.sync="guestCategoryDialogVisible" width="1000px" append-to-body
            custom-class="guest-category-dialog">
            <guest-type-list v-if="guestCategoryDialogVisible" ref="guestTypeListRef"></guest-type-list>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="guestCategoryDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmGuestCategorySelection">确定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import draggable from 'vuedraggable';
import McRichText from '../McRichText/index.vue';
import { richTextEventBus } from '../McRichText';
import ModuleTypeSelector from '../ModuleTypeSelector/index.vue';
import LiveList from "@/pages/mall/live/components/list.vue"
import LiveTypeList from "@/pages/mall/live/components/TypeList.vue"
import ArticleList from "@/pages/mall/material-center/components/ArticleList.vue"
import TypeMenu from "@/pages/mall/components/TypeMenu.vue"
import MaterialCenter from '@/pages/mall/material-center/index.vue'
import MaterialDialog from '../MaterialDialog/index.vue'
import GuestList from "@/pages/mall/guest/components/list.vue"
import GuestTypeList from "@/pages/mall/guest/components/TypeList.vue"
import { getLiveList, getLiveTypeList, getCategories, getSubCategories } from '@/api/material';
import { getGuestList, getGuestCategories } from '@/api/guest';
import { getArchiveList } from '@/api/schedule/archive'

// 不需要手动导入FaImageUpload，它已经全局注册了

export default {
    name: 'SchemaModuleEditor',

    components: {
        McRichText,
        ModuleTypeSelector,
        LiveList,
        LiveTypeList,
        ArticleList,
        TypeMenu,
        MaterialCenter,
        MaterialDialog,
        GuestList,
        GuestTypeList,
        draggable
    },

    props: {
        value: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: '模块列表'
        },
        max: {
            type: Number,
            default: 30
        }
    },

    data() {
        return {
            moduleList: this.value || [],
            dialogVisible: false,
            addDialogVisible: false,
            typeDialogVisible: false,
            currentIndex: -1,
            iconType: 'upload',
            moduleTypes: [
                { label: '活动简介', value: 'intro', icon: 'el-icon-tickets' },
                { label: '会场直播', value: 'live', icon: 'el-icon-video-camera' },
                { label: '新闻资讯', value: 'news', icon: 'el-icon-document' },
                { label: '图片集', value: 'images', icon: 'el-icon-picture' },
                { label: '视频集', value: 'videos', icon: 'el-icon-film' },
                { label: '文档中心', value: 'documents', icon: 'el-icon-folder' },
                { label: '个人中心', value: 'profile', icon: 'el-icon-user' },
                { label: '演讲嘉宾', value: 'speakers', icon: 'el-icon-microphone' },
                { label: '会议日程', value: 'schedule', icon: 'el-icon-date' },
                { label: '报名入口', value: 'register', icon: 'el-icon-s-promotion' },
                { label: '合作伙伴', value: 'partners', icon: 'el-icon-connection' },
                { label: '站外链接', value: 'external', icon: 'el-icon-link' },
                { label: '站内链接', value: 'internalLink', icon: 'el-icon-link' }
            ],
            currentModule: {
                title: '',
                subtitle: '',
                icon: 'el-icon-star-off',
                backgroundColor: '#ffffff',
                fontColor: '#333333',
                linkType: 'none',
                linkUrl: '',
                content: '',
                time: '',
                status: 'upcoming',
                description: '',
                source: '',
                publishTimeDate: '',
                publishTime: '',
                coverImage: '',
                displayMode: 'composite', // 默认使用组合模式
                buttonImage: '', // 纯图片模式下的按钮图片
            },
            newModule: {
                title: '',
                subtitle: '',
                linkType: 'intro'
            },
            liveDataLoading: false,
            existingLiveList: [],
            liveCategories: [],
            liveQueryParams: {
                page: 1,
                pageSize: 10,
                total: 0,
                category: '',
                subCategory: '',
            },
            selectedLiveItems: [],
            liveSelectDialogVisible: false,
            selectedLiveData: [],
            liveCategoryDialogVisible: false,
            selectedCategories: [],
            newsSelectDialogVisible: false,
            newsCategoryDialogVisible: false,
            newsCategories: [],
            newsSubcategories: [],
            selectedNewsSubcategories: [],
            imageCategoryDialogVisible: false,
            selectedImageSubcategories: [],
            imageSubcategories: [],
            materialDialogVisible: false,
            materialDialogData: null,
            videoCategoryDialogVisible: false,
            selectedVideoSubcategories: [],
            videoSubcategories: [],

            // 素材选择对话框数据
            materialDialogVisible: false,
            materialDialogData: {},
            materialDialogCallback: null, // 素材选择完成后的回调函数

            // 图片子分类
            imageSubcategories: [],
            selectedImageSubcategories: [],
            imageCategoryDialogVisible: false,

            // 视频子分类
            videoSubcategories: [],
            selectedVideoSubcategories: [],
            videoCategoryDialogVisible: false,

            // 新闻子分类
            newsSubcategories: [],
            selectedNewsSubcategories: [],
            newsCategoryDialogVisible: false,

            // 文档子分类
            documentSubcategories: [],
            selectedDocumentSubcategories: [],
            documentCategoryDialogVisible: false,

            // 合作伙伴配置
            partnersConfig: {
                dataSource: 'existing',
                style: 'grid',
                columns: '4',
                partnerList: [],
                selectedPartnerIds: [],
                tabs: []
            },
            partnerSubcategories: [],
            selectedPartnerSubcategories: [],
            partnerCategoryDialogVisible: false,

            // 嘉宾选择相关
            guestSelectDialogVisible: false,
            guestCategoryDialogVisible: false,
            selectedGuestData: [],
            guestCategories: [],
            guestQueryParams: {
                page: 1,
                pageSize: 10,
                total: 0,
                category: '',
                subCategory: ''
            },
            // 富文本编辑器内容
            content: '',
            // 当前组件类型
            componentType: '',
            // 当前分类和子分类
            category: '',
            subCategory: '',
            // 归档选项
            archiveOptions: [],
            // 形状选项
            shapeOptions: [
                {
                    text: '350 x 180',
                    label: '形状1(1.5x1格)',
                    value: 'shape1',
                },
                {
                    text: '226 x 180',
                    label: '形状2 (1x1格)',
                    value: 'shape2'
                },
                {
                    text: '350 x 380',
                    label: '形状3 (1.5x2格)',
                    value: 'shape3'
                },
                {
                    text: '720 x 180',
                    label: '形状4 (3x1)',
                    value: 'shape4'
                },
                {
                    text: '473 x 180',
                    label: '形状5 (2x1)',
                    value: 'shape5'
                }
            ],
        };
    },
    computed: {
        ...mapGetters(['project', 'curPage']),
        currentSiteId() {
            return this.curPage && this.curPage.site ? this.curPage.site : null;
        },
        availableSitePages() {
            if (this.project && this.project.pages && this.currentSiteId) {
                return this.project.pages.filter(page => page.site === this.currentSiteId);
            }
            return [];
        },
    },
    watch: {
        value: {
            handler(val) {
                this.moduleList = JSON.parse(JSON.stringify(val || []));
            },
            immediate: true,
            deep: true
        },

        dialogVisible(val) {
            console.log('dialogVisible 变化:', val);
            if (val) {
                // 当对话框打开时

                // 如果是日程模块，刷新归档数据
                if (this.currentModule && this.currentModule.linkType === 'schedule') {
                    console.log('打开日程模块编辑，准备获取归档数据');
                    this.getArchiveOptions();
                }

                // 当对话框打开时，通知富文本编辑器刷新
                setTimeout(() => {
                    console.log('对话框已打开，尝试刷新富文本编辑器');
                    richTextEventBus?.$emit('dialog-opened');
                }, 100);
            }
        },

        'currentModule.imagesConfig.tabs': {
            handler(val) {
                if (val && Array.isArray(val) && val.length > 0) {
                    // 如果有tabs，自动设置数据源为dynamic
                    if (this.currentModule.imagesConfig) {
                        this.$set(this.currentModule.imagesConfig, 'dataSource', 'dynamic');
                        console.log('检测到图片tabs，设置数据源为dynamic', {
                            tabs: val,
                            dataSource: this.currentModule.imagesConfig.dataSource
                        });
                    }
                }
            },
            deep: true
        },
        'currentModule.linkType': {
            handler(newType) {
                try {
                    if (!this.currentModule) return;

                    console.log('选择模块类型:', newType, '标题:', this.currentModule.title);

                    // 根据新类型自动调整标题
                    switch (newType) {
                        // ... existing cases ...

                        case 'register':
                            if (!this.currentModule.title || this.currentModule.title === '新模块') {
                                this.currentModule.title = '报名入口';
                            }
                            if (!this.currentModule.subtitle) {
                                this.currentModule.subtitle = '';
                            }
                            // 设置报名入口模块的默认样式为黑色字体、白色背景
                            this.currentModule.backgroundColor = '#ffffff';
                            this.currentModule.fontColor = '#333333';
                            if (!this.currentModule.icon) {
                                this.currentModule.icon = ''; // 不设置默认图标
                            }
                            break;

                        // ... existing cases ...
                    }
                } catch (error) {
                    console.error('处理模块类型变化时出错:', error);
                }
            },
            immediate: true,
            deep: true
        }
    },

    mounted() {
        // 在组件加载完成后，检查现有直播数据的状态
        this.$nextTick(() => {
            this.updateExistingLiveStatus();
        });
    },

    methods: {
        // 更新现有已选直播的状态
        updateExistingLiveStatus() {
            if (this.moduleList && this.moduleList.length > 0) {
                // 遍历所有模块
                this.moduleList.forEach(module => {
                    // 只处理直播类型模块
                    if (module.linkType === 'live' && module.liveConfig && module.liveConfig.liveList) {
                        // 处理每个直播项
                        module.liveConfig.liveList.forEach(liveItem => {
                            // 如果状态是中文，转换为英文状态
                            if (liveItem.status === '已结束') {
                                liveItem.status = 'ended';
                            } else if (liveItem.status === '直播中') {
                                liveItem.status = 'live';
                            } else if (liveItem.status === '回放') {
                                liveItem.status = 'replay';
                            } else if (liveItem.status === '即将开始') {
                                liveItem.status = 'upcoming';
                            }

                            // 如果有时间但没有状态，尝试根据时间计算状态
                            if (!liveItem.status && (liveItem.startTime || liveItem.liveTime)) {
                                const startTime = liveItem.startTime || liveItem.liveTime;
                                const endTime = liveItem.endTime || liveItem.overTime;
                                liveItem.status = this.calculateLiveStatus(startTime, endTime);
                            }
                        });
                    }
                });
            }
        },

        getLinkTypeName(type) {
            const typeMap = {
                'intro': '活动简介',
                'live': '会场直播',
                'news': '新闻资讯',
                'images': '图片集',
                'videos': '视频集',
                'documents': '文档中心',
                'profile': '个人中心',
                'speakers': '演讲嘉宾',
                'schedule': '会议日程',
                'register': '报名入口',
                'partners': '合作伙伴',
                'external': '站外链接',
                'internalLink': '站内链接',
            };

            return typeMap[type] || '未知类型';
        },

        isImageUrl(url) {
            if (!url) return false;
            return typeof url === 'string' && (
                url.startsWith('http') ||
                url.startsWith('https') ||
                url.includes('data:image')
            );
        },

        removeIcon() {
            this.currentModule.icon = '';
        },

        openModuleDialog() {
            if (this.moduleList.length >= this.max) {
                this.$message.warning(`最多只能添加${this.max}个模块`);
                return;
            }

            // 显示模块类型选择对话框
            this.typeDialogVisible = true;
        },

        handleModuleTypeSelect(type) {
            this.typeDialogVisible = false;
            this.currentIndex = -1;

            const moduleType = typeof type === 'object' ? type.value : (type || 'none');
            const title = this.getLinkTypeName(moduleType);

            this.currentModule = {
                title: title,
                subtitle: '',
                icon: '',
                backgroundColor: '#ffffff',
                fontColor: '#333333',
                linkType: moduleType,
                linkUrl: '',
                content: '',
                images: [],
                videos: [],
                documents: [],
                liveUrl: '',
                time: '',
                status: 'upcoming',
                description: '',
                source: '',
                publishTimeDate: '',
                publishTime: '',
                coverImage: '',
                displayMode: 'composite', // 添加默认显示模式
                buttonImage: '', // 添加按钮图片字段
            };

            // 为站外链接设置特定属性
            if (moduleType === 'external') {
                this.currentModule.openType = '_blank'; // 默认在新窗口打开
                this.currentModule.linkDescription = ''; // 初始化链接描述
            }

            this.dialogVisible = true;
        },

        addNewModule() {
            if (!this.newModule.title.trim()) {
                this.$message.warning('请输入模块标题');
                return;
            }

            // 创建新模块
            const module = {
                title: this.newModule.title,
                subtitle: this.newModule.subtitle || '',
                icon: '', // 默认为空
                backgroundColor: '#ffffff',
                fontColor: '#333333',
                linkType: this.newModule.linkType,
                linkUrl: '',
                shape: 'shape1', // 默认形状
                requiresRegistration: false // 默认不需要报名后进入
            };

            // 添加到模块列表
            this.moduleList.push(module);
            this.$emit('input', this.moduleList);

            this.addDialogVisible = false;

            // 立即打开编辑对话框
            this.currentIndex = this.moduleList.length - 1;
            this.currentModule = JSON.parse(JSON.stringify(this.moduleList[this.currentIndex]));
            this.iconType = this.isImageUrl(this.currentModule.icon) ? 'upload' : 'class';
            this.dialogVisible = true;
        },

        editModule(module) {
            // 获取模块在列表中的索引
            const index = this.moduleList.findIndex(item => item === module);

            console.log('编辑模块:', {
                模块索引: index,
                模块类型: module.linkType,
                模块标题: module.title,
            });

            if (index > -1) {
                this.currentIndex = index;
                this.currentModule = JSON.parse(JSON.stringify(module));
                this.iconType = this.isImageUrl(this.currentModule.icon) ? 'upload' : 'class';

                // 初始化图片模块链接类型
                if (this.currentModule.linkType === 'images' && this.currentModule.imagesConfig && this.currentModule.imagesConfig.imageList) {
                    this.currentModule.imagesConfig.imageList.forEach(imageItem => {
                        if (imageItem.linkUrl && imageItem.linkUrl.startsWith('internal://')) {
                            this.$set(imageItem, 'linkTargetType', 'internal');
                            this.$set(imageItem, 'internalPageId', imageItem.linkUrl.replace('internal://', ''));
                        } else {
                            this.$set(imageItem, 'linkTargetType', 'external');
                            this.$set(imageItem, 'internalPageId', null); // 清空可能存在的旧值
                        }
                    });
                }

                // 确保speakers类型模块有正确的初始化配置
                if (this.currentModule.linkType === 'speakers') {
                    console.log('初始化嘉宾配置前:', this.currentModule.speakersConfig);

                    if (!this.currentModule.speakersConfig) {
                        console.log('嘉宾配置不存在，将进行初始化');
                        this.initializeSpeakersConfig();
                    }

                    console.log('初始化嘉宾配置后:', this.currentModule.speakersConfig);
                }

                // 确保schedule类型模块有正确的初始化配置
                if (this.currentModule.linkType === 'schedule') {
                    if (!this.currentModule.scheduleConfig) {
                        this.initializeScheduleConfig();
                    } else {
                        // 无论如何都重新获取归档选项
                        this.getArchiveOptions();
                    }
                }

                console.log('设置对话框可见 (dialogVisible = true)');
                this.dialogVisible = true;

                console.log('对话框状态:', {
                    dialogVisible: this.dialogVisible,
                    currentModule: this.currentModule.linkType
                });
            }
        },

        saveModule() {
            if (!this.currentModule.title.trim()) {
                this.$message.warning('请输入模块标题');
                return;
            }
            if (this.currentModule.linkType == 'internalLink' && !this.currentModule.internalLink) {
                this.$message.warning('请选择站内链接');
                return;
            }

            // 处理图片模块链接
            if (this.currentModule.linkType === 'images' && this.currentModule.imagesConfig && this.currentModule.imagesConfig.imageList) {
                this.currentModule.imagesConfig.imageList.forEach(imageItem => {
                    if (imageItem.linkTargetType === 'internal' && imageItem.internalPageId) {
                        imageItem.linkUrl = `internal://${imageItem.internalPageId}`;
                    } else if (imageItem.linkTargetType === 'external') {
                        // linkUrl 已经是用户输入的外部链接，无需转换
                        // 但要确保 internalPageId 在这种情况下是无效的，或者在切换时已清空
                        delete imageItem.internalPageId;
                    } else {
                        // 如果没有明确的 linkTargetType 或者 internalPageId 不存在，则清空 linkUrl
                        imageItem.linkUrl = '';
                        delete imageItem.internalPageId;
                    }
                });
            }

            // 调试信息：保存前富文本内容
            console.log('保存前检查 - 富文本内容:', this.currentModule.content);
            console.log('保存前检查 - 富文本内容长度:', this.currentModule.content ? this.currentModule.content.length : 0);

            // 调试信息：输出形状设置
            console.log('保存前检查 - 形状设置:', this.currentModule.shape);

            // 处理日期时间格式
            this.updatePublishTime();

            // 处理直播类型的特殊配置
            if (this.currentModule.linkType === 'live' && !this.currentModule.liveConfig) {
                this.initializeLiveConfig();
            }

            // 处理日程类型的特殊配置
            if (this.currentModule.linkType === 'schedule' && !this.currentModule.scheduleConfig) {
                this.initializeScheduleConfig();
            }

            // 创建要保存的模块对象 - 使用深拷贝避免引用问题
            const moduleToSave = JSON.parse(JSON.stringify(this.currentModule));

            // 调试信息：序列化后的富文本内容
            console.log('JSON序列化后 - 富文本内容:', moduleToSave.content);
            console.log('JSON序列化后 - 富文本内容长度:', moduleToSave.content ? moduleToSave.content.length : 0);

            // 更新或新增模块
            if (this.currentIndex > -1 && this.currentIndex < this.moduleList.length) {
                // 更新现有模块
                this.$set(this.moduleList, this.currentIndex, moduleToSave);
            } else {
                // 新增模块
                this.moduleList.push(moduleToSave);
            }

            // 通知父组件数据变更
            this.$emit('input', this.moduleList);

            this.$message.success('保存成功');
            this.dialogVisible = false;
        },

        deleteModule(index) {
            const module = this.moduleList[index];
            const moduleTypeName = this.getLinkTypeName(module.linkType);

            this.$confirm(`确定要删除"${module.title}"(${moduleTypeName})模块吗?`, '删除确认', {
                confirmButtonText: '确定删除',
                cancelButtonText: '取消',
                type: 'warning',
                distinguishCancelAndClose: true
            }).then(() => {
                // 删除模块
                this.moduleList.splice(index, 1);

                // 通知父组件数据变更
                this.$emit('input', this.moduleList);

                // 显示成功消息
                this.$message({
                    type: 'success',
                    message: `已删除"${module.title}"模块`,
                    duration: 2000
                });
            }).catch(() => {
                // 用户取消，不做任何操作
            });
        },

        updatePublishTime() {
            if (this.currentModule.publishTimeDate) {
                const date = new Date(this.currentModule.publishTimeDate);
                this.currentModule.publishTime = date.toLocaleDateString() + ' ' + date.toLocaleTimeString('zh-CN', { hour12: false });
            }
        },

        getModuleTypeTitle(type) {
            const typeMap = {
                'intro': '活动简介',
                'live': '会场直播',
                'news': '新闻资讯',
                'images': '图片集',
                'videos': '视频集',
                'documents': '文档中心',
                'profile': '个人中心',
                'speakers': '演讲嘉宾',
                'schedule': '会议日程',
                'register': '报名入口',
                'partners': '合作伙伴',
                'external': '站外链接',
                'internalLink': '站内链接',
            };

            return typeMap[type] || '未知类型';
        },

        getModuleTypeIcon(type) {
            const typeMap = {
                'intro': 'el-icon-tickets',
                'live': 'el-icon-video-camera',
                'news': 'el-icon-document',
                'images': 'el-icon-picture',
                'videos': 'el-icon-film',
                'documents': 'el-icon-folder',
                'profile': 'el-icon-user',
                'speakers': 'el-icon-microphone',
                'schedule': 'el-icon-date',
                'register': 'el-icon-s-promotion',
                'partners': 'el-icon-connection',
                'external': 'el-icon-link'
            };

            return typeMap[type] || 'el-icon-star-off';
        },

        getModuleDialogTitle() {
            const typeMap = {
                'intro': '活动简介',
                'live': '会场直播',
                'news': '新闻资讯',
                'images': '图片集',
                'videos': '视频集',
                'documents': '文档中心',
                'profile': '个人中心',
                'speakers': '演讲嘉宾',
                'schedule': '会议日程',
                'register': '报名入口',
                'partners': '合作伙伴',
                'external': '站外链接',
                'internalLink': '站内链接',
            };

            const title = typeMap[this.currentModule.linkType];
            console.log('当前模块类型:', this.currentModule.linkType, '标题:', title);
            return title || '模块管理';
        },

        // 图片管理方法
        addImage() {
            if (!this.currentModule.images) {
                this.$set(this.currentModule, 'images', []);
            }
            this.currentModule.images.push({
                url: '',
                title: ''
            });
        },

        removeImage(index) {
            this.currentModule.images.splice(index, 1);
        },

        // 视频管理方法
        addVideo() {
            if (!this.currentModule.videos) {
                this.$set(this.currentModule, 'videos', []);
            }
            this.currentModule.videos.push({
                url: '',
                poster: '',
                title: '',
                description: ''
            });
        },

        removeVideo(index) {
            this.currentModule.videos.splice(index, 1);
        },

        // 文档管理方法
        addDocument() {
            if (!this.currentModule.documents) {
                this.$set(this.currentModule, 'documents', []);
            }
            this.currentModule.documents.push({
                url: '',
                title: '',
                size: 0
            });
        },

        removeDocument(index) {
            this.currentModule.documents.splice(index, 1);
        },

        // 初始化直播配置
        initializeLiveConfig() {
            if (!this.currentModule.liveConfig) {
                this.$set(this.currentModule, 'liveConfig', {
                    dataSource: 'existing', // 默认从直播管理选择
                    style: 'scroll',        // 默认滑动样式
                    max: '2',               // 默认一行显示2个
                    liveList: [],
                    selectedLiveIds: [],    // 存储已选择的直播ID
                    tabs: []                // 存储直播分类列表（用于dynamic数据源）
                });
            } else if (this.currentModule.liveConfig.dataSource !== 'existing' &&
                this.currentModule.liveConfig.dataSource !== 'dynamic') {
                // 如果数据源不是有效的类型，恢复为默认的直播管理选择
                this.currentModule.liveConfig.dataSource = 'existing';
            }

            // 如果旧数据兼容 - 将旧的直播属性转为列表项
            if (this.currentModule.liveConfig.liveList.length === 0 &&
                (this.currentModule.liveUrl || this.currentModule.time)) {
                this.currentModule.liveConfig.liveList.push({
                    title: this.currentModule.title || '默认直播',
                    status: this.currentModule.status || 'upcoming',
                    image: this.currentModule.image || this.currentModule.coverImage || '',
                    liveUrl: this.currentModule.liveUrl || '',
                    startTime: this.currentModule.time || '',
                    description: this.currentModule.description || '',
                    category: '',
                    viewCount: 0
                });
            }

            // 处理固定样式到滑动/列表的转换 (兼容旧数据)
            if (this.currentModule.liveConfig.style === 'fixed') {
                this.currentModule.liveConfig.style = 'list';
            }

            // 确保selectedLiveIds总是存在
            if (!this.currentModule.liveConfig.selectedLiveIds) {
                this.currentModule.liveConfig.selectedLiveIds = [];
            }

            // 确保tabs总是存在（用于dynamic数据源）
            if (!this.currentModule.liveConfig.tabs) {
                this.currentModule.liveConfig.tabs = [];
            }
        },

        // 获取直播状态文本
        getLiveStatusText(status) {
            // 如果状态本身就是中文，直接返回
            if (status === '直播中' || status === '即将开始' || status === '已结束' || status === '回放') {
                return status;
            }

            // 否则按英文状态代码转换
            const statusMap = {
                live: '直播中',
                upcoming: '即将开始',
                ended: '已结束',
                replay: '回放'
            };
            return statusMap[status] || status || '即将开始';
        },

        // 获取直播状态类
        getLiveStatusClass(status) {
            // 将中文状态转为对应的英文类名
            if (status === '直播中') return 'status-live';
            if (status === '即将开始') return 'status-upcoming';
            if (status === '已结束') return 'status-ended';
            if (status === '回放') return 'status-replay';

            // 英文状态直接使用
            return `status-${status || 'upcoming'}`;
        },

        // 根据时间自动计算直播状态
        calculateLiveStatus(startTime, endTime) {
            if (!startTime) return 'upcoming';

            const now = new Date();
            const start = new Date(startTime);

            // 如果有结束时间
            if (endTime) {
                const end = new Date(endTime);

                // 如果当前时间在开始时间之前
                if (now < start) {
                    return 'upcoming';
                }
                // 如果当前时间在开始和结束时间之间
                else if (now >= start && now <= end) {
                    return 'live';
                }
                // 如果当前时间在结束时间之后
                else {
                    return 'ended';
                }
            }
            // 没有结束时间的情况
            else {
                // 如果开始时间是未来时间，即将开始
                if (now < start) {
                    return 'upcoming';
                }
                // 如果开始时间在1小时内，认为是直播中
                else if ((now - start) <= 3600000) {
                    return 'live';
                }
                // 如果开始时间是过去时间且超过1小时，认为已结束
                else {
                    return 'ended';
                }
            }
        },

        // 获取现有直播数据
        async fetchExistingLiveData() {
            try {
                this.liveDataLoading = true;

                // 如果是第一次加载，同时获取分类
                if (this.liveCategories.length === 0) {
                    this.fetchLiveCategories();
                }

                const { page, pageSize, category, subCategory } = this.liveQueryParams;
                const response = await getLiveList({
                    category,
                    subCategory,
                    page,
                    pageSize
                });

                if (response && response.status === '10000' && response.data?.rooms) {
                    const roomData = response.data.rooms;
                    const total = response.data.total || 0;

                    // 更新总数
                    this.liveQueryParams.total = total;

                    // 转换数据格式并标记选中状态 - 确保使用直播管理的数据结构
                    this.existingLiveList = roomData.map(item => {
                        // 处理API返回的中文状态
                        let status = 'upcoming';
                        if (item.status === '已结束') {
                            status = 'ended';
                        } else if (item.status === '直播中') {
                            status = 'live';
                        } else if (item.status === '回放') {
                            status = 'replay';
                        } else if (item.status === '即将开始') {
                            status = 'upcoming';
                        }

                        return {
                            id: item._id,
                            title: item.title,
                            image: this.processImageUrl(item.cover || item.image),
                            liveUrl: item.liveUrl,
                            watchCount: item.views || item.watchCount || 0,
                            status: status,
                            description: item.description || '',
                            startTime: item.liveTime || item.startTime || '',
                            endTime: item.overTime || item.endTime || '',
                            selected: this.currentModule.liveConfig.selectedLiveIds.includes(item._id)
                        };
                    });
                } else {
                    this.existingLiveList = [];
                    this.$message.warning(response?.message || '获取直播数据失败');
                }
            } catch (error) {
                console.error('获取直播数据失败:', error);
                this.$message.error('获取直播数据失败，请稍后重试');
                this.existingLiveList = [];
            } finally {
                this.liveDataLoading = false;
            }
        },

        // 获取直播分类
        async fetchLiveCategories() {
            try {
                const response = await getLiveTypeList();
                if (response && response.status === '10000' && response.data) {
                    this.liveCategories = response.data;
                } else {
                    this.liveCategories = [];
                }
            } catch (error) {
                console.error('获取直播分类失败:', error);
                this.liveCategories = [];
            }
        },

        // 处理直播选择
        handleLiveSelection(selectedLives) {
            console.log('原始选中的直播数据:', JSON.stringify(selectedLives));

            // 为每个选中的直播添加状态信息
            this.selectedLiveData = selectedLives.map(live => ({
                ...live,
                _id: live.id, // 确保ID字段一致性
                status: live.status || '即将开始', // 如果没有状态，默认为"即将开始"
                title: live.title,
                cover: live.image,
                liveUrl: live.liveUrl,
                views: live.watchCount,
                description: live.description || '',
                liveTime: live.startTime || '',
                overTime: live.endTime || ''
            }));

            console.log('处理后的直播数据:', JSON.stringify(this.selectedLiveData));
        },

        // 确认直播选择
        confirmLiveSelection() {
            if (!this.currentModule.liveConfig) {
                this.initializeLiveConfig();
            }

            // 确保数据源设置为从直播管理选择
            this.currentModule.liveConfig.dataSource = 'existing';

            if (this.selectedLiveData && this.selectedLiveData.length > 0) {
                console.log('开始处理选择的直播数据:', this.selectedLiveData);

                // 将选中的直播数据转换为组件需要的格式，保持原始状态
                const newLiveList = this.selectedLiveData.map(live => {
                    const item = {
                        id: live._id,
                        title: live.title,
                        image: this.processImageUrl(live.cover || live.image),
                        liveUrl: live.liveUrl,
                        status: live.status, // 保持原始状态
                        description: live.description || '',
                        startTime: live.liveTime || '',
                        endTime: live.overTime || '',
                        viewCount: live.views || 0,
                        category: live.category || ''
                    };

                    console.log('处理后的直播项:', {
                        title: item.title,
                        originalStatus: live.status,
                        finalStatus: item.status
                    });

                    return item;
                });

                // 获取现有的直播ID列表
                const existingIds = this.currentModule.liveConfig.selectedLiveIds || [];

                // 过滤掉已存在的直播，只添加新的
                const newLives = newLiveList.filter(live => !existingIds.includes(live.id));

                // 追加新的直播到列表中
                this.currentModule.liveConfig.liveList = [
                    ...(this.currentModule.liveConfig.liveList || []),
                    ...newLives
                ];

                // 更新selectedLiveIds，添加新的ID
                this.currentModule.liveConfig.selectedLiveIds = [
                    ...existingIds,
                    ...newLives.map(item => item.id)
                ];

                console.log('已追加直播数据:', {
                    newCount: newLives.length,
                    totalCount: this.currentModule.liveConfig.liveList.length,
                    liveList: this.currentModule.liveConfig.liveList.map(item => ({
                        title: item.title,
                        status: item.status
                    }))
                });
            }

            this.liveSelectDialogVisible = false;
        },

        // 打开直播选择对话框
        openLiveSelectDialog() {
            this.liveSelectDialogVisible = true;
        },

        // 选择直播数据
        selectLiveData() {
            if (!this.currentModule || !this.currentModule.liveConfig) {
                this.initializeLiveConfig();
            }

            // 确保selectedLiveIds已初始化
            if (!this.currentModule.liveConfig.selectedLiveIds) {
                this.currentModule.liveConfig.selectedLiveIds = [];
            }

            // 确保liveList已初始化
            if (!this.currentModule.liveConfig.liveList) {
                this.currentModule.liveConfig.liveList = [];
            }

            // 打开直播选择对话框
            this.liveSelectDialogVisible = true;
        },

        // 选择直播分类
        selectLiveCategory() {
            if (!this.currentModule || !this.currentModule.liveConfig) {
                this.initializeLiveConfig();
            }

            // 确保tabs已初始化
            if (!this.currentModule.liveConfig.tabs) {
                this.currentModule.liveConfig.tabs = [];
            }

            // 打开分类选择对话框
            this.liveCategoryDialogVisible = true;

            // 在下一个事件循环中确保组件已经挂载
            this.$nextTick(() => {
                // 预设选中的分类
                if (this.currentModule.liveConfig.tabs && this.currentModule.liveConfig.tabs.length > 0) {
                    this.selectedCategories = [...this.currentModule.liveConfig.tabs];
                    // 如果组件已经挂载并有方法可用，则设置预选项
                    const typeListComponent = this.$refs.liveTypeListRef;
                    if (typeListComponent && typeof typeListComponent.selectItems === 'function') {
                        typeListComponent.selectItems(this.selectedCategories);
                    }
                }
            });
        },

        // 确认分类选择
        confirmCategorySelection() {
            if (!this.currentModule.liveConfig) {
                this.initializeLiveConfig();
            }

            // 获取LiveTypeList组件选中的分类
            const typeListComponent = this.$refs.liveTypeListRef;
            if (typeListComponent && typeof typeListComponent.getCheckedList === 'function') {
                const selectedCategories = typeListComponent.getCheckedList();

                if (Array.isArray(selectedCategories)) {
                    // 更新当前模块的分类列表
                    this.currentModule.liveConfig.tabs = selectedCategories;

                    console.log('已选择直播分类:', {
                        count: selectedCategories.length,
                        categories: selectedCategories
                    });
                }
            }

            this.liveCategoryDialogVisible = false;
        },

        processImageUrl(url) {
            // 检查是否为有效的图片URL
            if (!this.isImageUrl(url)) {
                return '';
            }

            // URL已经包含尺寸参数的情况下，不再添加
            if (url.includes('?width=') || url.includes('&width=') ||
                url.includes('?height=') || url.includes('&height=') ||
                url.includes('?w=') || url.includes('&w=') ||
                url.includes('?h=') || url.includes('&h=')) {
                return url;
            }

            // 添加尺寸限制参数（适用于支持此类参数的图片服务器）
            // 如果原URL已包含查询参数，使用&符号，否则使用?符号
            const separator = url.includes('?') ? '&' : '?';
            return `${url}${separator}width=100&height=100&fit=contain`;
        },

        // 初始化新闻配置
        initializeNewsConfig() {
            if (!this.currentModule.newsConfig) {
                this.$set(this.currentModule, 'newsConfig', {
                    dataSource: 'existing', // 默认为选择数据源
                    style: 'list',          // 固定使用列表样式
                    max: '1',
                    selectedNewsIds: [],
                    newsList: [],
                    tabs: [] // 用于存储选择的分类
                });
            } else {
                // 确保所有必须的属性都存在
                if (!this.currentModule.newsConfig.dataSource) {
                    this.currentModule.newsConfig.dataSource = 'existing';
                } else if (this.currentModule.newsConfig.dataSource !== 'existing' &&
                    this.currentModule.newsConfig.dataSource !== 'dynamic') {
                    // 如果数据源不是有效的类型，恢复为默认的选择数据源
                    this.currentModule.newsConfig.dataSource = 'existing';
                }

                // 固定使用列表样式
                this.currentModule.newsConfig.style = 'list';

                // 确保max属性存在
                if (!this.currentModule.newsConfig.max) {
                    this.currentModule.newsConfig.max = '1';
                }

                // 确保selectedNewsIds总是存在
                if (!this.currentModule.newsConfig.selectedNewsIds) {
                    this.currentModule.newsConfig.selectedNewsIds = [];
                }

                // 确保newsList总是存在
                if (!this.currentModule.newsConfig.newsList) {
                    this.currentModule.newsConfig.newsList = [];
                }

                // 确保tabs总是存在（用于dynamic数据源）
                if (!this.currentModule.newsConfig.tabs) {
                    this.currentModule.newsConfig.tabs = [];
                }
            }

            console.log('已初始化新闻配置:', this.currentModule.newsConfig);
        },

        // 选择新闻数据
        selectNewsData() {
            if (!this.currentModule || !this.currentModule.newsConfig) {
                this.initializeNewsConfig();
            }

            // 确保selectedNewsIds已初始化
            if (!this.currentModule.newsConfig.selectedNewsIds) {
                this.currentModule.newsConfig.selectedNewsIds = [];
            }

            // 确保newsList已初始化
            if (!this.currentModule.newsConfig.newsList) {
                this.currentModule.newsConfig.newsList = [];
            }

            // 打开新闻选择对话框
            this.newsSelectDialogVisible = true;
        },

        // 选择新闻分类
        async selectNewsCategory() {
            try {
                // 初始化分类数据
                await this.getNewsCategories();

                // 设置默认选中的分类
                if (this.currentModule?.newsConfig?.tabs && this.currentModule.newsConfig.tabs.length > 0) {
                    this.selectedNewsSubcategories = this.currentModule.newsConfig.tabs
                        .map(tab => tab._id)
                        .filter(id => this.newsSubcategories.some(sub => sub._id === id));
                } else {
                    this.selectedNewsSubcategories = [];
                }

                // 显示分类选择对话框
                this.newsCategoryDialogVisible = true;
            } catch (error) {
                console.error('打开分类选择对话框失败:', error);
                this.$message.error('打开分类选择对话框失败');
            }
        },

        // 确认分类选择
        confirmNewsSubcategorySelection() {
            try {
                // 确保newsConfig已初始化
                if (!this.currentModule.newsConfig) {
                    this.currentModule.newsConfig = {};
                }

                // 根据选择的ID查找完整的子分类对象
                const selectedSubcategories = this.newsSubcategories.filter(
                    subcategory => this.selectedNewsSubcategories.includes(subcategory._id)
                );

                console.log('已选择的子分类:', selectedSubcategories);

                // 更新当前模块的tabs配置
                this.currentModule.newsConfig.tabs = selectedSubcategories;

                // 关闭分类选择对话框
                this.newsCategoryDialogVisible = false;

                this.$message.success(`已选择${selectedSubcategories.length}个子分类`);
            } catch (error) {
                console.error('确认分类选择失败:', error);
                this.$message.error('确认分类选择失败');
            }
        },

        // 获取新闻分类数据
        async getNewsCategories() {
            try {
                // 使用已导入的API函数
                const response = await getCategories();

                if (response && response.status === '10000' && Array.isArray(response.data)) {
                    // 固定使用ID为"670e74efaf089a40acf16add"的新闻分类
                    const articleCategory = response.data.find(category => category._id === "670e74efaf089a40acf16add");

                    if (articleCategory && articleCategory.subCategories && articleCategory.subCategories.length > 0) {
                        // 直接存储子分类列表，用于显示和选择
                        this.newsSubcategories = articleCategory.subCategories.map(sub => ({
                            _id: sub._id,
                            name: sub.name,
                            parentId: articleCategory._id,
                            parentName: articleCategory.name
                        }));

                        // 仍然保留原来的格式化用于兼容
                        this.newsCategories = [
                            {
                                id: articleCategory._id,
                                name: articleCategory.name,
                                children: articleCategory.subCategories.map(sub => ({
                                    id: sub._id,
                                    name: sub.name,
                                    parentId: articleCategory._id
                                }))
                            }
                        ];

                        console.log('成功获取新闻分类:', articleCategory.name, '包含子分类:', this.newsSubcategories.length);

                        // 如果当前模块已经有选择的子分类，预先选中它们
                        if (this.currentModule?.newsConfig?.tabs && this.currentModule.newsConfig.tabs.length > 0) {
                            this.selectedNewsSubcategories = this.currentModule.newsConfig.tabs
                                .map(tab => tab._id)
                                .filter(id => this.newsSubcategories.some(sub => sub._id === id));
                        } else {
                            this.selectedNewsSubcategories = [];
                        }
                    } else {
                        console.error('未找到ID为670e74efaf089a40acf16add的新闻分类或该分类没有子分类');
                        this.$message.error('未找到新闻分类数据');
                        this.newsCategories = [];
                        this.newsSubcategories = [];
                    }
                } else {
                    console.error('获取新闻分类失败:', response?.message || '未知错误');
                    this.$message.error(response?.message || '获取新闻分类失败');
                    this.newsCategories = [];
                    this.newsSubcategories = [];
                }
            } catch (error) {
                console.error('获取新闻分类出错:', error);
                this.$message.error('获取新闻分类失败，请稍后重试');
                this.newsCategories = [];
                this.newsSubcategories = [];
            }
        },

        // 确认新闻数据选择
        confirmNewsDataSelection() {
            if (!this.currentModule.newsConfig) {
                this.initializeNewsConfig();
            }

            // 确保数据源设置为从新闻管理选择
            this.currentModule.newsConfig.dataSource = 'existing';

            if (this.selectedNewsData && this.selectedNewsData.length > 0) {
                // 将选中的新闻数据转换为组件需要的格式
                const newNewsList = this.selectedNewsData.map(news => ({
                    id: news._id || news.id,
                    title: news.title,
                    cover: this.processImageUrl(news.cover || news.image),
                    content: news.content || '',
                    source: news.source || '',
                    publishTime: news.updatedAt || news.publishTime || new Date().toISOString(),
                }));

                // 获取现有的新闻ID列表
                const existingIds = this.currentModule.newsConfig.selectedNewsIds || [];

                // 过滤掉已存在的新闻，只添加新的
                const newNews = newNewsList.filter(news => !existingIds.includes(news.id));

                // 追加新的新闻到列表中
                this.currentModule.newsConfig.newsList = [
                    ...(this.currentModule.newsConfig.newsList || []),
                    ...newNews
                ];

                // 更新selectedNewsIds，添加新的ID
                this.currentModule.newsConfig.selectedNewsIds = [
                    ...existingIds,
                    ...newNews.map(item => item.id)
                ];

                console.log('已追加新闻数据:', {
                    newCount: newNews.length,
                    totalCount: this.currentModule.newsConfig.selectedNewsIds.length,
                    selectedIds: this.currentModule.newsConfig.selectedNewsIds,
                    dataSource: this.currentModule.newsConfig.dataSource,
                    newsList: this.currentModule.newsConfig.newsList
                });
            } else {
                console.warn('未选择任何新闻数据');
            }

            this.newsSelectDialogVisible = false;
        },

        // 处理新闻分类选择
        handleNewsSelection(selectedNews) {
            this.selectedNewsData = selectedNews;
            console.log('Selected news data:', selectedNews.length);
        },

        formatDate(dateString) {
            if (!dateString) return '';

            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return dateString;

                return date.toLocaleDateString('zh-CN', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                }).replace(/\//g, '-');
            } catch (e) {
                return dateString;
            }
        },

        // 选择新闻
        selectNews() {
            if (!this.currentModule || !this.currentModule.newsConfig) {
                this.initializeNewsConfig();
            }

            // 确保selectedNewsIds已初始化
            if (!this.currentModule.newsConfig.selectedNewsIds) {
                this.currentModule.newsConfig.selectedNewsIds = [];
            }

            // 确保newsList已初始化
            if (!this.currentModule.newsConfig.newsList) {
                this.currentModule.newsConfig.newsList = [];
            }

            // 打开新闻选择对话框
            this.newsSelectDialogVisible = true;
        },

        // 删除直播项目
        removeLiveItem(index) {
            const item = this.currentModule.liveConfig.liveList[index];
            this.currentModule.liveConfig.liveList.splice(index, 1);
            // 同时从selectedLiveIds中移除
            const idIndex = this.currentModule.liveConfig.selectedLiveIds.indexOf(item.id);
            if (idIndex > -1) {
                this.currentModule.liveConfig.selectedLiveIds.splice(idIndex, 1);
            }
        },

        // 删除新闻项目
        removeNewsItem(index) {
            const item = this.currentModule.newsConfig.newsList[index];
            this.currentModule.newsConfig.newsList.splice(index, 1);
            // 同时从selectedNewsIds中移除
            const idIndex = this.currentModule.newsConfig.selectedNewsIds.indexOf(item.id);
            if (idIndex > -1) {
                this.currentModule.newsConfig.selectedNewsIds.splice(idIndex, 1);
            }
        },

        // 初始化图片配置
        initializeImagesConfig() {
            // 如果imagesConfig不存在则创建
            if (!this.currentModule.imagesConfig) {
                this.$set(this.currentModule, 'imagesConfig', {
                    dataSource: 'existing',
                    style: 'grid',
                    columns: 2,
                    autoplay: false,
                    interval: 3000,
                    max: 6,
                    imageList: [],
                    selectedImageIds: [],
                    tabs: []
                });
            } else {
                // 确保所有必须的属性都存在
                const defaults = {
                    dataSource: 'existing',
                    style: 'grid',
                    columns: 2,
                    autoplay: false,
                    interval: 3000,
                    max: 6,
                    imageList: [],
                    selectedImageIds: [],
                    tabs: []
                };
                for (const key in defaults) {
                    if (!this.currentModule.imagesConfig.hasOwnProperty(key)) {
                        this.$set(this.currentModule.imagesConfig, key, defaults[key]);
                    }
                }
            }

            // 检查现有的图片列表，确保每个图片对象都有链接相关属性
            if (this.currentModule.imagesConfig.imageList && this.currentModule.imagesConfig.imageList.length > 0) {
                this.currentModule.imagesConfig.imageList.forEach(item => {
                    this._initializeLinkProperties(item);
                });
            }

            console.log('已初始化图片配置:', JSON.parse(JSON.stringify(this.currentModule.imagesConfig)));
            return this.currentModule.imagesConfig;
        },

        // 处理图片选择
        handleImageSelected(items) {
            console.log('处理图片选择:', items);
            console.log('接收到的原始数据结构:', JSON.stringify(items, null, 2));
            console.log('接收到的原始数据类型:', typeof items, Array.isArray(items) ? 'Array' : 'Not Array');

            if (Array.isArray(items) && items.length > 0) {
                // 检查data中的第一个元素是否是特殊对象
                console.log('第一个元素的类型:', typeof items[0]);
                console.log('第一个元素的所有属性:', Object.keys(items[0]));
                console.log('第一个元素的内容字段:', items[0].content);
                console.log('第一个元素的_id字段:', items[0]._id);
            }

            // 如果data是数组的数组，或者有特殊结构，尝试提取
            if (Array.isArray(items) && items.length > 0 && Array.isArray(items[0]?.materials)) {
                console.log('检测到嵌套结构，尝试提取材料');
                const materials = [];
                items.forEach(category => {
                    if (category.materials && Array.isArray(category.materials)) {
                        materials.push(...category.materials);
                    }
                });
                console.log('提取的材料:', materials);
                // 使用提取的材料替换原始数据
                items = materials;
            }

            try {
                // 确保配置对象已初始化
                if (!this.currentModule.imagesConfig) {
                    this.initializeImagesConfig();
                }

                // 设置数据源为existing
                this.$set(this.currentModule.imagesConfig, 'dataSource', 'existing');

                // 清空tabs，避免混合dynamic和existing数据源
                this.$set(this.currentModule.imagesConfig, 'tabs', []);

                if (items && items.length > 0) {
                    // 打印第一个项目的完整结构，便于调试
                    console.log('第一个图片项目的完整结构:', JSON.stringify(items[0]));

                    // 记录选择的图片ID
                    const selectedIds = items.map(item => item._id);

                    // 更新选中的图片ID列表
                    this.currentModule.imagesConfig.selectedImageIds = selectedIds;

                    // 更新图片列表，保留现有项并添加新项
                    const existingIds = (this.currentModule.imagesConfig.imageList || []).map(img => img.id);
                    const newItems = items.filter(item => !existingIds.includes(item._id));

                    // 转换新项到我们的图片格式 - 修正字段映射
                    const formattedNewItems = newItems.map(item => ({
                        id: item._id,
                        title: item.title || item.name || '图片',
                        // 确保content字段被正确赋值
                        url: item.content || item.url || item.cover || item.path || '',
                        content: item.content || item.url || item.cover || item.path || '',
                        cover: item.cover || item.content || item.url || item.path || '',
                        path: item.path || item.url || item.content || item.cover || '',
                        description: item.description || item.summary || '',
                        publishTime: item.publishTime || item.updatedAt || new Date().toISOString()
                    }));

                    console.log('格式化后的新图片项目:', formattedNewItems);

                    // 合并现有项与新项
                    if (this.currentModule.imagesConfig.imageList && this.currentModule.imagesConfig.imageList.length > 0) {
                        // 过滤掉未选中的项
                        const filteredExistingItems = this.currentModule.imagesConfig.imageList.filter(
                            item => selectedIds.includes(item.id)
                        );

                        // 合并并去重
                        this.currentModule.imagesConfig.imageList = [
                            ...filteredExistingItems,
                            ...formattedNewItems
                        ];
                    } else {
                        // 如果之前没有图片，直接使用新选择的图片
                        this.currentModule.imagesConfig.imageList = formattedNewItems;
                    }

                    // 更新旧的images数组（兼容性）
                    this.currentModule.images = [...this.currentModule.imagesConfig.imageList];

                    console.log('更新后的图片列表:', this.currentModule.imagesConfig.imageList);
                    this.$message.success(`已选择${items.length}张图片`);
                } else {
                    console.warn('没有选择任何图片');
                    this.$message.warning('没有选择任何图片');
                }
            } catch (error) {
                console.error('处理图片选择错误:', error);
                this.$message.error('处理图片选择失败');
            }
        },

        // 选择图片
        selectImages() {
            console.log('打开图片选择对话框');

            // 确保配置对象存在
            if (!this.currentModule.imagesConfig) {
                this.initializeImagesConfig();
            }

            // 设置素材对话框数据 - 修改type为对应MaterialDialog组件能理解的类型
            this.materialDialogData = {
                type: 'image', // 调整为MaterialDialog所期望的类型
                multiple: true,
                categoryId: '670e74efaf089a40acf16ad9', // 图片分类ID
                title: '选择图片',
                materialType: 'images' // 添加一个明确的材料类型字段
            };

            console.log('素材对话框数据:', this.materialDialogData);

            // 打开素材选择对话框
            this.materialDialogVisible = true;
        },

        // 移除图片
        removeImageItem(index) {
            // 获取要删除的图片项
            const image = this.currentModule.imagesConfig.imageList[index];

            // 从imageList中移除
            this.currentModule.imagesConfig.imageList.splice(index, 1);

            // 同时更新images数组（用于兼容）
            this.currentModule.images = [...this.currentModule.imagesConfig.imageList];

            // 从selectedImageIds中移除
            const idIndex = this.currentModule.imagesConfig.selectedImageIds.indexOf(image.id);
            if (idIndex > -1) {
                this.currentModule.imagesConfig.selectedImageIds.splice(idIndex, 1);
            }

            this.$message.success('已删除一张图片');
        },

        // 视频管理方法
        addVideo() {
            if (!this.currentModule.videos) {
                this.$set(this.currentModule, 'videos', []);
            }
            this.currentModule.videos.push({
                url: '',
                poster: '',
                title: '',
                description: ''
            });
        },

        removeVideo(index) {
            this.currentModule.videos.splice(index, 1);
        },

        // 文档管理方法
        addDocument() {
            if (!this.currentModule.documents) {
                this.$set(this.currentModule, 'documents', []);
            }
            this.currentModule.documents.push({
                url: '',
                title: '',
                size: 0
            });
        },

        removeDocument(index) {
            this.currentModule.documents.splice(index, 1);
        },

        // 初始化视频配置
        initializeVideosConfig() {
            if (!this.currentModule.videosConfig) {
                this.$set(this.currentModule, 'videosConfig', {
                    dataSource: 'existing',
                    style: 'fixed',
                    columns: 2,
                    showControls: true,
                    playMode: 'default',
                    showInfo: true,
                    loop: true,
                    videoList: [],
                    selectedVideoIds: [],
                    tabs: []
                });
            } else {
                // 确保所有必须的属性都存在
                if (!this.currentModule.videosConfig.dataSource) {
                    this.currentModule.videosConfig.dataSource = 'existing';
                }
                if (!this.currentModule.videosConfig.style) {
                    this.currentModule.videosConfig.style = 'fixed';
                }
                if (!this.currentModule.videosConfig.columns) {
                    this.currentModule.videosConfig.columns = 2;
                }
                if (!this.currentModule.videosConfig.showControls) {
                    this.currentModule.videosConfig.showControls = 'show';
                }
                if (!this.currentModule.videosConfig.playMode) {
                    this.currentModule.videosConfig.playMode = 'default';
                }
                if (typeof this.currentModule.videosConfig.showInfo !== 'boolean') {
                    this.currentModule.videosConfig.showInfo = true;
                }
                if (!Array.isArray(this.currentModule.videosConfig.videoList)) {
                    this.currentModule.videosConfig.videoList = [];
                }
                if (!Array.isArray(this.currentModule.videosConfig.selectedVideoIds)) {
                    this.currentModule.videosConfig.selectedVideoIds = [];
                }
                if (!Array.isArray(this.currentModule.videosConfig.tabs)) {
                    this.currentModule.videosConfig.tabs = [];
                }
            }

            console.log('已初始化视频配置:', this.currentModule.videosConfig);
        },

        selectVideos() {
            this.initializeVideosConfig();

            this.materialDialogVisible = true;
            this.materialDialogData = {
                type: 'video',
                multiple: true,
                categoryId: '670e74efaf089a40acf16adb', // 视频分类ID
                title: '选择视频',
                materialType: 'videos' // 添加一个明确的材料类型字段
            };

            console.log('素材对话框数据:', this.materialDialogData);
        },

        // 删除视频项目
        removeVideoItem(index) {
            const item = this.currentModule.videosConfig.videoList[index];
            this.currentModule.videosConfig.videoList.splice(index, 1);
            // 同时从selectedVideoIds中移除
            const idIndex = this.currentModule.videosConfig.selectedVideoIds.indexOf(item.id);
            if (idIndex > -1) {
                this.currentModule.videosConfig.selectedVideoIds.splice(idIndex, 1);
            }
        },

        // 选择视频分类
        async selectVideoCategory() {
            try {
                // 获取视频分类数据
                const response = await getSubCategories({ categoryId: '670e74efaf089a40acf16adb' }); // 视频分类ID

                if (response && response.status === '10000' && Array.isArray(response.data)) {
                    // 更新视频子分类列表
                    this.videoSubcategories = response.data.map(sub => ({
                        _id: sub._id,
                        name: sub.name
                    }));

                    // 设置默认选中的分类
                    if (this.currentModule?.videosConfig?.tabs && this.currentModule.videosConfig.tabs.length > 0) {
                        this.selectedVideoSubcategories = this.currentModule.videosConfig.tabs
                            .map(tab => tab._id)
                            .filter(id => this.videoSubcategories.some(sub => sub._id === id));
                    } else {
                        this.selectedVideoSubcategories = [];
                    }

                    // 显示分类选择对话框
                    this.videoCategoryDialogVisible = true;

                    console.log('打开视频分类选择对话框:', {
                        totalCategories: this.videoSubcategories.length,
                        selectedCategories: this.selectedVideoSubcategories
                    });
                } else {
                    throw new Error(response?.message || '获取分类数据失败');
                }
            } catch (error) {
                console.error('选择分类失败:', error);
                this.$message.error('获取分类数据失败，请稍后重试');
            }
        },

        // 确认视频分类选择
        confirmVideoSubcategorySelection() {
            try {
                // 确保videosConfig已初始化
                if (!this.currentModule.videosConfig) {
                    this.initializeVideosConfig();
                }

                // 根据选择的ID查找完整的子分类对象
                const selectedSubcategories = this.videoSubcategories.filter(
                    subcategory => this.selectedVideoSubcategories.includes(subcategory._id)
                );

                console.log('已选择的视频子分类:', selectedSubcategories);

                // 更新当前模块的tabs配置
                this.currentModule.videosConfig.tabs = selectedSubcategories;

                // 设置数据源为dynamic，并确保不会被覆盖
                this.$set(this.currentModule.videosConfig, 'dataSource', 'dynamic');

                // 清空静态视频列表，避免冲突
                this.$set(this.currentModule.videosConfig, 'videoList', []);
                this.$set(this.currentModule.videosConfig, 'selectedVideoIds', []);

                // 关闭分类选择对话框
                this.videoCategoryDialogVisible = false;

                console.log('更新后的视频配置:', {
                    dataSource: this.currentModule.videosConfig.dataSource,
                    tabs: this.currentModule.videosConfig.tabs,
                    videoList: this.currentModule.videosConfig.videoList
                });

                this.$message.success(`已选择${selectedSubcategories.length}个视频子分类`);
            } catch (error) {
                console.error('确认视频分类选择失败:', error);
                this.$message.error('确认视频分类选择失败');
            }
        },

        handleMaterialSelected(selectedItems) {
            console.log('[DEBUG] UNIFIED handleMaterialSelected - START');
            console.log('[DEBUG] UNIFIED handleMaterialSelected - received selectedItems:', JSON.parse(JSON.stringify(selectedItems)));
            console.log('[DEBUG] UNIFIED handleMaterialSelected - materialDialogData.materialType FROM DIALOG DATA:', this.materialDialogData ? this.materialDialogData.materialType : 'MATERIAL DIALOG DATA UNDEFINED');

            try {
                if (!selectedItems || selectedItems.length === 0) {
                    this.$message.warning('未选择任何素材');
                    this.materialDialogVisible = false;
                    console.log('[DEBUG] UNIFIED handleMaterialSelected - No items selected, exiting.');
                    return;
                }

                // IMPORTANT: Determine materialType from this.materialDialogData, NOT from a parameter
                const materialType = this.materialDialogData ? this.materialDialogData.materialType : null;
                if (!materialType) {
                    console.error('[DEBUG] UNIFIED handleMaterialSelected - materialType is missing from materialDialogData. Cannot proceed.');
                    this.$message.error('素材类型配置错误，无法处理选择。');
                    this.materialDialogVisible = false;
                    return;
                }

                console.log('[DEBUG] UNIFIED handleMaterialSelected - Determined materialType:', materialType);

                let configName, listName, idFieldName, titleFieldName, urlFieldName, coverFieldName, contentFieldName;

                switch (materialType) {
                    case 'images':
                        configName = 'imagesConfig'; listName = 'imageList'; idFieldName = '_id'; titleFieldName = 'title'; urlFieldName = 'content'; coverFieldName = 'cover'; contentFieldName = 'content';
                        if (!this.currentModule.imagesConfig) this.initializeImagesConfig();
                        this.$set(this.currentModule.imagesConfig, 'dataSource', 'existing');
                        this.$set(this.currentModule.imagesConfig, 'tabs', []);
                        break;
                    case 'videos':
                        configName = 'videosConfig'; listName = 'videoList'; idFieldName = '_id'; titleFieldName = 'title'; urlFieldName = 'content'; coverFieldName = 'poster'; contentFieldName = 'content';
                        if (!this.currentModule.videosConfig) this.initializeVideosConfig();
                        this.$set(this.currentModule.videosConfig, 'dataSource', 'existing');
                        this.$set(this.currentModule.videosConfig, 'tabs', []);
                        break;
                    case 'documents':
                        configName = 'documentsConfig'; listName = 'documentList'; idFieldName = '_id'; titleFieldName = 'title'; urlFieldName = 'fileUrl'; coverFieldName = null; contentFieldName = 'content';
                        if (!this.currentModule.documentsConfig) this.initializeDocumentsConfig();
                        this.$set(this.currentModule.documentsConfig, 'dataSource', 'existing');
                        this.$set(this.currentModule.documentsConfig, 'tabs', []);
                        break;
                    case 'partners':
                        configName = 'partnersConfig'; listName = 'partnerList'; idFieldName = '_id'; titleFieldName = 'title'; urlFieldName = 'content'; coverFieldName = 'cover'; contentFieldName = 'content';
                        if (!this.currentModule.partnersConfig) this.initializePartnersConfig();
                        this.$set(this.currentModule.partnersConfig, 'dataSource', 'existing');
                        this.$set(this.currentModule.partnersConfig, 'tabs', []);
                        break;
                    // Removed 'news' case for now as it was handled by a specific handler, if we unify, it should be here.
                    default:
                        console.warn('[DEBUG] UNIFIED handleMaterialSelected - Unknown materialType in switch:', materialType);
                        this.$message.warning('不支持的素材类型或配置错误');
                        this.materialDialogVisible = false;
                        return;
                }

                console.log(`[DEBUG] UNIFIED handleMaterialSelected - configName: ${configName}, listName: ${listName}`);

                const newFormattedList = selectedItems.map(item => ({
                    id: item[idFieldName] || item.id || `temp_id_${Date.now()}_${Math.random()}`,
                    title: item[titleFieldName] || item.name || '未命名项目',
                    url: item[urlFieldName] || item.url || '',
                    cover: coverFieldName ? (item[coverFieldName] || item.cover || item[urlFieldName] || item.url || '') : undefined,
                    content: contentFieldName ? (item[contentFieldName] || item.content || '') : undefined,
                    path: item.path || '',
                    description: item.description || item.summary || '',
                    publishTime: item.publishTime || item.updatedAt || new Date().toISOString(),
                    linkUrl: '',
                    linkTargetType: 'external',
                    internalPageId: null
                }));
                console.log('[DEBUG] UNIFIED handleMaterialSelected - newFormattedList:', JSON.parse(JSON.stringify(newFormattedList)));

                console.log(`[DEBUG] UNIFIED handleMaterialSelected - BEFORE assignment: currentModule.${configName}.${listName}`, this.currentModule[configName] ? JSON.parse(JSON.stringify(this.currentModule[configName][listName])) : 'CONFIG UNDEFINED');
                // 直接替换数组以确保响应性
                if (this.currentModule[configName]) {
                    this.currentModule[configName][listName] = [...newFormattedList];
                } else {
                    // 如果 config 对象本身就不存在，需要先创建它
                    this.$set(this.currentModule, configName, { [listName]: [...newFormattedList] });
                }
                console.log(`[DEBUG] UNIFIED handleMaterialSelected - AFTER assignment: currentModule.${configName}.${listName}`, this.currentModule[configName] ? JSON.parse(JSON.stringify(this.currentModule[configName][listName])) : 'CONFIG UNDEFINED');

                const selectedIdsListKey = `selected${materialType.charAt(0).toUpperCase() + materialType.slice(1)}Ids`;
                if (this.currentModule[configName] && this.currentModule[configName].hasOwnProperty(selectedIdsListKey)) {
                    console.log(`[DEBUG] UNIFIED handleMaterialSelected - BEFORE assignment for selectedIdsListKey (${selectedIdsListKey}):`, JSON.parse(JSON.stringify(this.currentModule[configName][selectedIdsListKey])));
                    this.currentModule[configName][selectedIdsListKey] = newFormattedList.map(item => item.id);
                    console.log(`[DEBUG] UNIFIED handleMaterialSelected - AFTER assignment for selectedIdsListKey (${selectedIdsListKey}):`, JSON.parse(JSON.stringify(this.currentModule[configName][selectedIdsListKey])));
                }

                if (materialType === 'images' && this.currentModule.hasOwnProperty('images')) {
                    console.log('[DEBUG] UNIFIED handleMaterialSelected - Updating legacy this.currentModule.images');
                    this.currentModule.images = [...newFormattedList];
                }
                if (materialType === 'partners' && this.currentModule.hasOwnProperty('partners')) {
                    console.log('[DEBUG] UNIFIED handleMaterialSelected - Updating legacy this.currentModule.partners');
                    this.currentModule.partners = [...newFormattedList];
                }

                this.$message.success(`已选择${selectedItems.length}个${this.materialDialogData.title || '素材'}`);

            } catch (error) {
                console.error('[DEBUG] UNIFIED handleMaterialSelected - ERROR:', error);
                this.$message.error('处理素材选择失败');
            } finally {
                this.materialDialogVisible = false;
                let listToLog;
                try {
                    const tempMaterialType = this.materialDialogData ? this.materialDialogData.materialType : 'unknown';
                    let tempConfigName = 'unknownConfig';
                    let tempListName = 'unknownList';
                    if (tempMaterialType === 'images') { tempConfigName = 'imagesConfig'; tempListName = 'imageList'; }
                    else if (tempMaterialType === 'videos') { tempConfigName = 'videosConfig'; tempListName = 'videoList'; }
                    else if (tempMaterialType === 'documents') { tempConfigName = 'documentsConfig'; tempListName = 'documentList'; }
                    else if (tempMaterialType === 'partners') { tempConfigName = 'partnersConfig'; tempListName = 'partnerList'; }
                    listToLog = this.currentModule[tempConfigName] ? JSON.parse(JSON.stringify(this.currentModule[tempConfigName][tempListName])) : 'N/A for type ' + tempMaterialType;
                } catch (e) {
                    listToLog = 'Error getting list for logging: ' + e.message;
                }
                console.log(`[DEBUG] UNIFIED handleMaterialSelected - BEFORE $forceUpdate - list for ${this.materialDialogData ? this.materialDialogData.materialType : 'unknown'}:`, listToLog);
                this.$forceUpdate();
                try {
                    const tempMaterialType = this.materialDialogData ? this.materialDialogData.materialType : 'unknown';
                    let tempConfigName = 'unknownConfig';
                    let tempListName = 'unknownList';
                    if (tempMaterialType === 'images') { tempConfigName = 'imagesConfig'; tempListName = 'imageList'; }
                    else if (tempMaterialType === 'videos') { tempConfigName = 'videosConfig'; tempListName = 'videoList'; }
                    else if (tempMaterialType === 'documents') { tempConfigName = 'documentsConfig'; tempListName = 'documentList'; }
                    else if (tempMaterialType === 'partners') { tempConfigName = 'partnersConfig'; tempListName = 'partnerList'; }
                    listToLog = this.currentModule[tempConfigName] ? JSON.parse(JSON.stringify(this.currentModule[tempConfigName][tempListName])) : 'N/A for type ' + tempMaterialType;
                } catch (e) {
                    listToLog = 'Error getting list for logging after forceUpdate: ' + e.message;
                }
                console.log(`[DEBUG] UNIFIED handleMaterialSelected - AFTER $forceUpdate - list for ${this.materialDialogData ? this.materialDialogData.materialType : 'unknown'}:`, listToLog);
                console.log('[DEBUG] UNIFIED handleMaterialSelected - END');
            }
        },

        // 处理视频选择
        handleVideoSelected(items) {
            console.log('处理视频选择:', items);
            console.log('接收到的视频数据结构:', JSON.stringify(items, null, 2));

            // 如果items是数组的数组，或者有特殊结构，尝试提取
            if (Array.isArray(items) && items.length > 0 && Array.isArray(items[0]?.materials)) {
                console.log('检测到嵌套结构，尝试提取视频材料');
                const materials = [];
                items.forEach(category => {
                    if (category.materials && Array.isArray(category.materials)) {
                        materials.push(...category.materials);
                    }
                });
                console.log('提取的视频材料:', materials);
                // 使用提取的材料替换原始数据
                items = materials;
            }

            // 确保配置对象已初始化
            if (!this.currentModule.videosConfig) {
                this.initializeVideosConfig();
            }

            // 设置数据源为existing
            this.$set(this.currentModule.videosConfig, 'dataSource', 'existing');

            // 清空tabs，避免混合dynamic和existing数据源
            this.$set(this.currentModule.videosConfig, 'tabs', []);

            if (items && items.length > 0) {
                // 记录选择的视频ID
                const selectedIds = items.map(item => item._id || item.id);

                // 更新选中的视频ID列表
                this.currentModule.videosConfig.selectedVideoIds = selectedIds;

                // 更新视频列表，保留现有项并添加新项
                const existingIds = (this.currentModule.videosConfig.videoList || []).map(v => v.id);
                const newItems = items.filter(item => !existingIds.includes(item._id || item.id));

                // 转换新项到我们的视频格式
                const formattedNewItems = newItems.map(item => ({
                    id: item._id || item.id,
                    title: item.title || item.name || '视频',
                    poster: item.poster || item.cover || '',
                    url: item.url || item.content || '',
                    content: item.content || item.url || '', // 保存content字段作为视频URL
                    description: item.summary || item.description || '',
                    publishTime: item.publishTime || item.updatedAt || new Date().toISOString()
                }));

                console.log('格式化后的新视频项目:', formattedNewItems);

                // 合并现有项与新项
                if (this.currentModule.videosConfig.videoList && this.currentModule.videosConfig.videoList.length > 0) {
                    // 过滤掉未选中的项
                    const filteredExistingItems = this.currentModule.videosConfig.videoList.filter(
                        item => selectedIds.includes(item.id)
                    );

                    // 合并并去重
                    this.currentModule.videosConfig.videoList = [
                        ...filteredExistingItems,
                        ...formattedNewItems
                    ];
                } else {
                    // 如果之前没有视频，直接使用新选择的视频
                    this.currentModule.videosConfig.videoList = formattedNewItems;
                }

                console.log('更新后的视频列表:', this.currentModule.videosConfig.videoList);
                this.$message.success(`已选择${items.length}个视频`);
            } else {
                console.warn('没有选择任何视频');
                this.$message.warning('没有选择任何视频');
            }
        },

        // 处理新闻选择
        handleNewsSelected(items) {
            console.log('处理新闻选择:', items);

            // 确保配置对象已初始化
            if (!this.currentModule.newsConfig) {
                this.initializeNewsConfig();
            }

            // 设置数据源为existing
            this.$set(this.currentModule.newsConfig, 'dataSource', 'existing');

            // 清空tabs，避免混合dynamic和existing数据源
            this.$set(this.currentModule.newsConfig, 'tabs', []);

            if (items && items.length > 0) {
                // 记录选择的新闻ID
                const selectedIds = items.map(item => item.id);

                // 更新选中的新闻ID列表
                this.currentModule.newsConfig.selectedNewsIds = selectedIds;

                // 更新新闻列表，保留现有项并添加新项
                const existingIds = (this.currentModule.newsConfig.newsList || []).map(n => n.id);
                const newItems = items.filter(item => !existingIds.includes(item.id));

                // 转换新项到我们的新闻格式
                const formattedNewItems = newItems.map(item => ({
                    id: item.id,
                    title: item.title || '新闻',
                    cover: item.cover || item.image || '',
                    content: item.content || '',
                    source: item.source || '',
                    summary: item.summary || item.description || '',
                    description: item.description || item.summary || '',
                    publishTime: item.publishTime || new Date().toISOString()
                }));

                // 合并现有项与新项
                if (this.currentModule.newsConfig.newsList && this.currentModule.newsConfig.newsList.length > 0) {
                    // 过滤掉未选中的项
                    const filteredExistingItems = this.currentModule.newsConfig.newsList.filter(
                        item => selectedIds.includes(item.id)
                    );

                    // 合并并去重
                    this.currentModule.newsConfig.newsList = [
                        ...filteredExistingItems,
                        ...formattedNewItems
                    ];
                } else {
                    // 如果之前没有新闻，直接使用新选择的新闻
                    this.currentModule.newsConfig.newsList = formattedNewItems;
                }

                console.log('更新后的新闻列表:', this.currentModule.newsConfig.newsList);
                this.$message.success(`已选择${items.length}个新闻`);
            } else {
                console.warn('没有选择任何新闻');
                this.$message.warning('没有选择任何新闻');
            }
        },

        // 选择图片分类
        async selectImageCategory() {
            try {
                // 获取图片分类数据
                const response = await getSubCategories({ categoryId: '670e74efaf089a40acf16ad9' }); // 图片分类ID

                if (response && response.status === '10000' && Array.isArray(response.data)) {
                    // 更新图片子分类列表
                    this.imageSubcategories = response.data.map(sub => ({
                        _id: sub._id,
                        name: sub.name
                    }));

                    // 设置默认选中的分类
                    if (this.currentModule?.imagesConfig?.tabs && this.currentModule.imagesConfig.tabs.length > 0) {
                        this.selectedImageSubcategories = this.currentModule.imagesConfig.tabs
                            .map(tab => tab._id)
                            .filter(id => this.imageSubcategories.some(sub => sub._id === id));
                    } else {
                        this.selectedImageSubcategories = [];
                    }

                    // 显示分类选择对话框
                    this.imageCategoryDialogVisible = true;

                    console.log('打开图片分类选择对话框:', {
                        totalCategories: this.imageSubcategories.length,
                        selectedCategories: this.selectedImageSubcategories
                    });
                } else {
                    throw new Error(response?.message || '获取分类数据失败');
                }
            } catch (error) {
                console.error('选择分类失败:', error);
                this.$message.error('获取分类数据失败，请稍后重试');
            }
        },

        // 确认图片分类选择
        confirmImageSubcategorySelection() {
            try {
                // 确保imagesConfig已初始化
                if (!this.currentModule.imagesConfig) {
                    this.initializeImagesConfig();
                }

                // 根据选择的ID查找完整的子分类对象
                const selectedSubcategories = this.imageSubcategories.filter(
                    subcategory => this.selectedImageSubcategories.includes(subcategory._id)
                );

                console.log('已选择的图片子分类:', selectedSubcategories);

                // 更新当前模块的tabs配置
                this.currentModule.imagesConfig.tabs = selectedSubcategories;

                // 设置数据源为dynamic，并确保不会被覆盖
                this.$set(this.currentModule.imagesConfig, 'dataSource', 'dynamic');

                // 清空静态图片列表，避免冲突
                this.$set(this.currentModule, 'images', []);
                this.$set(this.currentModule.imagesConfig, 'imageList', []);
                this.$set(this.currentModule.imagesConfig, 'selectedImageIds', []);

                // 关闭分类选择对话框
                this.imageCategoryDialogVisible = false;

                console.log('更新后的图片配置:', {
                    dataSource: this.currentModule.imagesConfig.dataSource,
                    tabs: this.currentModule.imagesConfig.tabs,
                    images: this.currentModule.images
                });

                this.$message.success(`已选择${selectedSubcategories.length}个图片子分类`);
            } catch (error) {
                console.error('确认图片分类选择失败:', error);
                this.$message.error('确认图片分类选择失败');
            }
        },

        // 查找处理图片模块的部分，确保正确传递图片配置
        generateModuleData() {
            // 创建模块数据的基础结构
            const moduleData = {
                id: this.currentModule.id,
                title: this.currentModule.title,
                icon: this.currentModule.icon,
                linkType: this.currentModule.linkType,
                type: this.currentModule.type,
                module: this.currentModule.module
            };

            // 根据链接类型，添加相应的数据
            if (this.currentModule.linkType === 'live') {
                // 如果是直播模块，添加直播配置
                moduleData.liveConfig = this.currentModule.liveConfig;
            } else if (this.currentModule.linkType === 'news') {
                // 如果是新闻模块，添加新闻配置
                moduleData.newsConfig = this.currentModule.newsConfig;
            } else if (this.currentModule.linkType === 'images') {
                // 如果是图片模块，添加图片列表和配置
                moduleData.imagesConfig = this.currentModule.imagesConfig || { dataSource: 'existing' };

                // 确保dataSource字段直接添加到顶层对象
                moduleData.dataSource = this.currentModule.imagesConfig?.dataSource || 'existing';

                // 如果使用动态数据源，确保tabs数据被正确传递
                if (moduleData.dataSource === 'dynamic' && this.currentModule.imagesConfig?.tabs) {
                    moduleData.tabs = this.currentModule.imagesConfig.tabs;
                    console.log('添加图片分类tabs到moduleData:', moduleData.tabs);
                } else if (moduleData.dataSource === 'existing') {
                    // 确保图片列表被正确传递
                    moduleData.images = this.currentModule.imagesConfig?.imageList || this.currentModule.images || [];
                    console.log('添加手动选择的图片列表到moduleData:', moduleData.images.length, '个图片');
                }
            } else if (this.currentModule.linkType === 'videos') {
                // 如果是视频模块，添加视频配置
                moduleData.videos = this.currentModule.videos || []; // 兼容旧版本
                moduleData.videosConfig = this.currentModule.videosConfig || { dataSource: 'existing' };

                // 确保dataSource字段直接添加到顶层对象
                moduleData.dataSource = this.currentModule.videosConfig?.dataSource || 'existing';

                // 根据不同的数据源，添加相应的数据
                if (moduleData.dataSource === 'dynamic' && this.currentModule.videosConfig?.tabs) {
                    // 如果是动态数据源，添加分类标签
                    moduleData.tabs = this.currentModule.videosConfig.tabs;
                    console.log('添加视频分类tabs到moduleData:', moduleData.tabs);
                } else if (moduleData.dataSource === 'existing') {
                    // 如果是手动选择的数据源，确保视频列表正确添加
                    moduleData.videos = this.currentModule.videosConfig?.videoList || this.currentModule.videos || [];
                    console.log('添加手动选择的视频列表到moduleData:', moduleData.videos.length, '个视频');
                }
            } else if (this.currentModule.linkType === 'documents') {
                // 如果是文档模块，添加文档配置
                moduleData.documents = this.currentModule.documents || []; // 兼容旧版本
                moduleData.documentsConfig = this.currentModule.documentsConfig || { dataSource: 'existing' };

                // 确保dataSource字段直接添加到顶层对象
                moduleData.dataSource = this.currentModule.documentsConfig?.dataSource || 'existing';

                // 根据不同的数据源，添加相应的数据
                if (moduleData.dataSource === 'dynamic' && this.currentModule.documentsConfig?.tabs) {
                    // 如果是动态数据源，添加分类标签
                    moduleData.tabs = this.currentModule.documentsConfig.tabs;
                    console.log('添加文档分类tabs到moduleData:', moduleData.tabs);
                } else if (moduleData.dataSource === 'existing') {
                    // 如果是手动选择的数据源，确保文档列表正确添加
                    moduleData.documents = [...(this.currentModule.documentsConfig?.documentList || this.currentModule.documents || [])];
                    console.log('添加手动选择的文档列表到moduleData:', {
                        数量: moduleData.documents.length,
                        示例: moduleData.documents.length > 0 ? {
                            id: moduleData.documents[0].id,
                            title: moduleData.documents[0].title
                        } : null
                    });
                }
            } else if (this.currentModule.linkType === 'partners') {
                // 如果是合作伙伴模块，添加合作伙伴列表和配置
                moduleData.partnersConfig = this.currentModule.partnersConfig || { dataSource: 'existing' };

                // 确保dataSource字段直接添加到顶层对象
                moduleData.dataSource = this.currentModule.partnersConfig?.dataSource || 'existing';

                // 如果使用动态数据源，确保tabs数据被正确传递
                if (moduleData.dataSource === 'dynamic' && this.currentModule.partnersConfig?.tabs) {
                    moduleData.tabs = this.currentModule.partnersConfig.tabs;
                    console.log('添加合作伙伴分类tabs到moduleData:', moduleData.tabs);
                } else if (moduleData.dataSource === 'existing') {
                    // 确保伙伴列表被正确传递
                    moduleData.partners = this.currentModule.partnersConfig?.partnerList || this.currentModule.partners || [];
                    console.log('添加手动选择的合作伙伴列表到moduleData:', moduleData.partners.length, '个合作伙伴');
                }
            }

            // 返回处理后的moduleData
            return moduleData;
        },

        handleDragChange() {
            // 当拖拽排序变化时触发更新
            this.$emit('input', [...this.moduleList]);
            this.$message.success('模块排序已更新');
        },

        // 文档管理方法
        addDocument() {
            if (!this.currentModule.documents) {
                this.$set(this.currentModule, 'documents', []);
            }
            this.currentModule.documents.push({
                url: '',
                title: '',
                size: 0
            });
        },

        removeDocument(index) {
            this.currentModule.documents.splice(index, 1);
        },

        // 初始化文档配置
        initializeDocumentsConfig() {
            if (!this.currentModule.documentsConfig) {
                this.$set(this.currentModule, 'documentsConfig', {
                    dataSource: 'existing',
                    documentList: [],
                    selectedDocumentIds: [],
                    tabs: [],
                    columns: 1
                });
            } else {
                const defaults = {
                    dataSource: 'existing',
                    documentList: [],
                    selectedDocumentIds: [],
                    tabs: [],
                    columns: 1
                };
                for (const key in defaults) {
                    if (!this.currentModule.documentsConfig.hasOwnProperty(key)) {
                        this.$set(this.currentModule.documentsConfig, key, defaults[key]);
                    }
                }
            }

            if (this.currentModule.documentsConfig.documentList && this.currentModule.documentsConfig.documentList.length > 0) {
                this.currentModule.documentsConfig.documentList.forEach(item => {
                    this._initializeLinkProperties(item);
                });
            }
            console.log('文档配置已初始化:', JSON.parse(JSON.stringify(this.currentModule.documentsConfig)));
            return this.currentModule.documentsConfig;
        },

        selectDocuments() {
            this.initializeDocumentsConfig();

            this.materialDialogVisible = true;
            this.materialDialogData = {
                type: 'document',
                multiple: true,
                categoryId: '670e74efaf089a40acf16ad7', // 文档分类ID
                title: '选择文档',
                materialType: 'documents' // 添加一个明确的材料类型字段
            };

            console.log('素材对话框数据:', this.materialDialogData);
        },

        // 删除文档项目
        removeDocumentItem(index) {
            const item = this.currentModule.documentsConfig.documentList[index];
            this.currentModule.documentsConfig.documentList.splice(index, 1);
            // 同时从selectedDocumentIds中移除
            const idIndex = this.currentModule.documentsConfig.selectedDocumentIds.indexOf(item.id);
            if (idIndex > -1) {
                this.currentModule.documentsConfig.selectedDocumentIds.splice(idIndex, 1);
            }

            this.$message.success('已删除一个文档');
        },

        // 处理文档选择
        handleDocumentSelected(items) {
            console.log('处理文档选择:', items);
            console.log('文档详细数据:', JSON.stringify(items));

            // 打印每个文档项的所有字段，帮助调试
            if (items && items.length > 0) {
                items.forEach((item, index) => {
                    console.log(`文档项 ${index} 的所有字段:`, Object.keys(item));
                    console.log(`文档项 ${index} 的完整数据:`, item);
                });
            }

            // 如果items是数组的数组，或者有特殊结构，尝试提取
            if (Array.isArray(items) && items.length > 0 && Array.isArray(items[0]?.materials)) {
                console.log('检测到嵌套结构，尝试提取文档材料');
                const materials = [];
                items.forEach(category => {
                    if (category.materials && Array.isArray(category.materials)) {
                        materials.push(...category.materials);
                    }
                });
                console.log('提取的文档材料:', materials);
                // 使用提取的材料替换原始数据
                items = materials;
            }

            // 确保配置对象已初始化
            if (!this.currentModule.documentsConfig) {
                this.initializeDocumentsConfig();
            }

            // 设置数据源为existing
            this.$set(this.currentModule.documentsConfig, 'dataSource', 'existing');

            // 清空tabs，避免混合dynamic和existing数据源
            this.$set(this.currentModule.documentsConfig, 'tabs', []);

            if (items && items.length > 0) {
                // 记录选择的文档ID
                const selectedIds = items.map(item => item._id || item.id);
                console.log('选择的文档ID:', selectedIds);

                // 更新选中的文档ID列表
                this.currentModule.documentsConfig.selectedDocumentIds = selectedIds;

                // 更新文档列表，保留现有项并添加新项
                const existingIds = (this.currentModule.documentsConfig.documentList || []).map(d => d.id);
                console.log('现有文档ID:', existingIds);
                const newItems = items.filter(item => !existingIds.includes(item._id || item.id));
                console.log('新增文档项:', newItems);

                console.log('处理前的文档标题:');
                newItems.forEach(item => console.log(`ID=${item._id}, 标题="${item.title}"`));

                // 转换新项到我们的文档格式
                const formattedNewItems = newItems.map(item => {
                    // 检查是否有实际文件URL
                    let fileUrl = '';
                    if (item.fileUrl && item.fileUrl.startsWith('http')) {
                        fileUrl = item.fileUrl;
                    } else if (item.url && item.url.startsWith('http')) {
                        fileUrl = item.url;
                    } else if (item.content && item.content.startsWith('http')) {
                        fileUrl = item.content;
                    }

                    // 确保使用原始标题
                    const formattedItem = {
                        id: item._id || item.id,
                        title: item.title || '未命名文档', // 仅使用原始标题
                        url: fileUrl,
                        fileUrl: fileUrl,
                        content: item.content || '',
                        size: item.size || 0,
                        description: item.description || item.summary || '',
                        fileType: fileUrl ? this.getFileTypeFromUrl(fileUrl) : '',
                        publishTime: item.publishTime || item.updatedAt || new Date().toISOString()
                    };

                    return formattedItem;
                });

                console.log('处理后的文档标题:');
                formattedNewItems.forEach(item => console.log(`ID=${item.id}, 标题="${item.title}"`));

                // 合并现有项与新项
                if (this.currentModule.documentsConfig.documentList && this.currentModule.documentsConfig.documentList.length > 0) {
                    // 过滤掉未选中的项
                    const filteredExistingItems = this.currentModule.documentsConfig.documentList.filter(
                        item => selectedIds.includes(item.id)
                    );

                    // 合并并去重
                    this.currentModule.documentsConfig.documentList = [
                        ...filteredExistingItems,
                        ...formattedNewItems
                    ];
                } else {
                    // 如果之前没有文档，直接使用新选择的文档
                    this.currentModule.documentsConfig.documentList = formattedNewItems;
                }

                // 同步到documents数组，保持兼容
                this.currentModule.documents = [...this.currentModule.documentsConfig.documentList];

                // 打印最终结果，确认标题是否正确
                console.log('最终文档列表数据:', this.currentModule.documentsConfig.documentList.map(doc => ({
                    id: doc.id,
                    title: doc.title
                })));

                this.$message.success(`已选择${items.length}个文档`);

                // 确保UI更新 - 强制Vue检测变化
                this.$forceUpdate();
            } else {
                console.warn('没有选择任何文档');
                this.$message.warning('没有选择任何文档');
            }
        },

        // 选择文档分类
        async selectDocumentCategory() {
            try {
                // 获取文档分类数据
                const response = await getSubCategories({ categoryId: '670e74efaf089a40acf16ad7' }); // 文档分类ID

                if (response && response.status === '10000' && Array.isArray(response.data)) {
                    // 更新文档子分类列表
                    this.documentSubcategories = response.data.map(sub => ({
                        _id: sub._id,
                        name: sub.name
                    }));

                    // 设置默认选中的分类
                    if (this.currentModule?.documentsConfig?.tabs && this.currentModule.documentsConfig.tabs.length > 0) {
                        this.selectedDocumentSubcategories = this.currentModule.documentsConfig.tabs
                            .map(tab => tab._id)
                            .filter(id => this.documentSubcategories.some(sub => sub._id === id));
                    } else {
                        this.selectedDocumentSubcategories = [];
                    }

                    // 显示分类选择对话框
                    this.documentCategoryDialogVisible = true;

                    console.log('打开文档分类选择对话框:', {
                        totalCategories: this.documentSubcategories.length,
                        selectedCategories: this.selectedDocumentSubcategories
                    });
                } else {
                    throw new Error(response?.message || '获取分类数据失败');
                }
            } catch (error) {
                console.error('选择分类失败:', error);
                this.$message.error('获取分类数据失败，请稍后重试');
            }
        },

        // 确认文档分类选择
        confirmDocumentSubcategorySelection() {
            try {
                // 确保documentsConfig已初始化
                if (!this.currentModule.documentsConfig) {
                    this.initializeDocumentsConfig();
                }

                // 根据选择的ID查找完整的子分类对象
                const selectedSubcategories = this.documentSubcategories.filter(
                    subcategory => this.selectedDocumentSubcategories.includes(subcategory._id)
                );

                console.log('已选择的文档子分类:', selectedSubcategories);

                // 更新当前模块的tabs配置
                this.currentModule.documentsConfig.tabs = selectedSubcategories;

                // 设置数据源为dynamic，并确保不会被覆盖
                this.$set(this.currentModule.documentsConfig, 'dataSource', 'dynamic');

                // 清空静态文档列表，避免冲突
                this.$set(this.currentModule, 'documents', []);
                this.$set(this.currentModule.documentsConfig, 'documentList', []);
                this.$set(this.currentModule.documentsConfig, 'selectedDocumentIds', []);

                // 关闭分类选择对话框
                this.documentCategoryDialogVisible = false;

                console.log('更新后的文档配置:', {
                    dataSource: this.currentModule.documentsConfig.dataSource,
                    tabs: this.currentModule.documentsConfig.tabs
                });

                this.$message.success(`已选择${selectedSubcategories.length}个文档子分类`);
            } catch (error) {
                console.error('确认文档分类选择失败:', error);
                this.$message.error('更新文档分类失败');
            }
        },

        // 删除文档标签
        removeDocumentTab(tabId) {
            if (this.currentModule.documentsConfig && this.currentModule.documentsConfig.tabs) {
                const index = this.currentModule.documentsConfig.tabs.findIndex(tab => tab._id === tabId);
                if (index > -1) {
                    this.currentModule.documentsConfig.tabs.splice(index, 1);
                }
            }
        },

        // 获取文件类型
        getFileTypeFromUrl(url) {
            if (!url) return '';

            try {
                if (!url.includes('.')) return '';

                // 正确提取扩展名
                let filename = url.split('/').pop();

                // 处理URL参数和片段
                if (filename.includes('?')) {
                    filename = filename.split('?')[0];
                }
                if (filename.includes('#')) {
                    filename = filename.split('#')[0];
                }

                const ext = filename.split('.').pop().toLowerCase();
                return ext;
            } catch (error) {
                console.error('获取文件类型失败:', error);
                return '';
            }
        },

        // 格式化文件大小
        formatFileSize(size) {
            if (!size) return '未知大小';

            const units = ['B', 'KB', 'MB', 'GB'];
            let i = 0;
            size = Number(size);

            while (size >= 1024 && i < units.length - 1) {
                size /= 1024;
                i++;
            }

            return size.toFixed(2) + ' ' + units[i];
        },

        // 初始化合作伙伴配置
        initializePartnersConfig() {
            if (!this.currentModule.partnersConfig) {
                this.$set(this.currentModule, 'partnersConfig', {
                    dataSource: 'existing',
                    style: 'grid',
                    columns: '4',
                    autoplay: false,
                    interval: 3000,
                    max: 12,
                    partnerList: [],
                    selectedPartnerIds: [],
                    tabs: []
                });
            } else {
                const defaults = {
                    dataSource: 'existing',
                    style: 'grid',
                    columns: '4',
                    autoplay: false,
                    interval: 3000,
                    max: 12,
                    partnerList: [],
                    selectedPartnerIds: [],
                    tabs: []
                };
                for (const key in defaults) {
                    if (!this.currentModule.partnersConfig.hasOwnProperty(key)) {
                        this.$set(this.currentModule.partnersConfig, key, defaults[key]);
                    }
                }
            }

            if (this.currentModule.partnersConfig.partnerList && this.currentModule.partnersConfig.partnerList.length > 0) {
                this.currentModule.partnersConfig.partnerList.forEach(item => {
                    this._initializeLinkProperties(item);
                });
            }
            console.log('已初始化合作伙伴配置:', JSON.parse(JSON.stringify(this.currentModule.partnersConfig)));
            return this.currentModule.partnersConfig;
        },

        // 选择合作伙伴
        selectPartners() {
            if (!this.currentModule.partnersConfig) {
                this.initializePartnersConfig();
            }

            // 设置数据源为静态
            this.$set(this.currentModule.partnersConfig, 'dataSource', 'existing');

            // 清空动态数据标签防止混淆
            this.$set(this.currentModule.partnersConfig, 'tabs', []);

            // 打开素材选择对话框，让统一的 handleMaterialSelected 处理结果
            this.openMaterialDialog('partner');
            // 注意：不再传递第二个回调函数参数
        },

        // 删除合作伙伴
        removePartnerItem(index) {
            if (!this.currentModule.partnersConfig) {
                this.initializePartnersConfig();
            }

            // 获取要删除的项
            const partner = this.currentModule.partnersConfig.partnerList[index];

            // 从列表中删除
            this.currentModule.partnersConfig.partnerList.splice(index, 1);

            // 更新旧数据结构
            this.currentModule.partners = [...this.currentModule.partnersConfig.partnerList];

            // 从选中ID中删除
            const idIndex = this.currentModule.partnersConfig.selectedPartnerIds.indexOf(partner.id);
            if (idIndex !== -1) {
                this.currentModule.partnersConfig.selectedPartnerIds.splice(idIndex, 1);
            }

            console.log('删除合作伙伴后:', {
                剩余: this.currentModule.partnersConfig.partnerList.length,
                selectedIds: this.currentModule.partnersConfig.selectedPartnerIds.length
            });
        },

        // 选择合作伙伴分类
        async selectPartnerCategories() {
            try {
                // 获取分类数据 (复用图片分类的API)
                const response = await getSubCategories({ categoryId: '670e74efaf089a40acf16ad9' }); // 图片分类ID

                if (response && response.status === '10000' && Array.isArray(response.data)) {
                    // 更新合作伙伴子分类列表
                    this.partnerSubcategories = response.data.map(sub => ({
                        _id: sub._id,
                        name: sub.name
                    }));

                    // 设置默认选中的分类 - 使用合作伙伴的tabs
                    if (this.currentModule?.partnersConfig?.tabs && this.currentModule.partnersConfig.tabs.length > 0) {
                        this.selectedPartnerSubcategories = this.currentModule.partnersConfig.tabs
                            .map(tab => tab._id)
                            .filter(id => this.partnerSubcategories.some(sub => sub._id === id));
                    } else {
                        this.selectedPartnerSubcategories = [];
                    }

                    // 显示分类选择对话框
                    this.partnerCategoryDialogVisible = true;

                    console.log('打开合作伙伴分类选择对话框:', {
                        totalCategories: this.partnerSubcategories.length,
                        selectedCategories: this.selectedPartnerSubcategories
                    });
                } else {
                    throw new Error(response?.message || '获取分类数据失败');
                }
            } catch (error) {
                console.error('选择分类失败:', error);
                this.$message.error('获取分类数据失败，请稍后重试');
            }
        },

        // 移除合作伙伴分类
        removePartnerTab(index) {
            if (this.currentModule.partnersConfig && this.currentModule.partnersConfig.tabs) {
                this.currentModule.partnersConfig.tabs.splice(index, 1);
                if (this.currentModule.partnersConfig.tabs.length === 0) {
                    // 如果没有分类了，提示用户
                    this.$message.warning('未选择任何合作伙伴分类，请至少选择一个');
                }
            }
        },

        // 确认合作伙伴分类选择
        confirmPartnerSubcategorySelection() {
            try {
                // 确保partnersConfig已初始化
                if (!this.currentModule.partnersConfig) {
                    this.initializePartnersConfig();
                }

                // 根据选择的ID查找完整的子分类对象
                const selectedSubcategories = this.partnerSubcategories.filter(
                    subcategory => this.selectedPartnerSubcategories.includes(subcategory._id)
                );

                console.log('已选择的合作伙伴子分类:', selectedSubcategories);

                // 更新当前模块的tabs配置
                this.currentModule.partnersConfig.tabs = selectedSubcategories;

                // 设置数据源为dynamic，并确保不会被覆盖
                this.$set(this.currentModule.partnersConfig, 'dataSource', 'dynamic');

                // 清空静态合作伙伴列表，避免冲突
                this.$set(this.currentModule, 'partners', []);
                this.$set(this.currentModule.partnersConfig, 'partnerList', []);
                this.$set(this.currentModule.partnersConfig, 'selectedPartnerIds', []);

                // 关闭分类选择对话框
                this.partnerCategoryDialogVisible = false;

                console.log('更新后的合作伙伴配置:', {
                    dataSource: this.currentModule.partnersConfig.dataSource,
                    tabs: this.currentModule.partnersConfig.tabs,
                    partners: this.currentModule.partners
                });

                this.$message.success(`已选择${selectedSubcategories.length}个合作伙伴子分类`);
            } catch (error) {
                console.error('确认合作伙伴分类选择失败:', error);
                this.$message.error('确认合作伙伴分类选择失败');
            }
        },

        // 打开素材对话框的通用方法
        openMaterialDialog(type, callback) {
            console.log('[DEBUG] openMaterialDialog called with type:', type);

            let categoryId = '670e74efaf089a40acf16ad9'; // 默认为图片分类ID
            let materialType = 'images'; // Corresponds to switch cases in handleMaterialSelected
            let dialogTitle = '选择图片';
            let actualTypeForDialog = 'image'; // Type expected by MaterialDialog component

            if (type === 'video') {
                categoryId = '670e74efaf089a40acf16adb';
                materialType = 'videos';
                dialogTitle = '选择视频';
                actualTypeForDialog = 'video';
            } else if (type === 'document') {
                categoryId = '670e74efaf089a40acf16ad7';
                materialType = 'documents';
                dialogTitle = '选择文档';
                actualTypeForDialog = 'document';
            } else if (type === 'news' || type === 'article') {
                categoryId = '670e74efaf089a40acf16adc';
                materialType = 'news'; // Assuming 'news' is a case in handleMaterialSelected
                dialogTitle = '选择文章';
                actualTypeForDialog = 'article';
            } else if (type === 'partner') { // Added for partners, assuming they use image assets
                categoryId = '670e74efaf089a40acf16ad9'; // Use image category for partners
                materialType = 'partners';
                dialogTitle = '选择合作伙伴素材';
                actualTypeForDialog = 'image';
            }

            this.materialDialogData = {
                type: actualTypeForDialog, // This is the type MaterialDialog expects
                multiple: true,
                categoryId: categoryId,
                title: dialogTitle,
                materialType: materialType // This is for our internal logic in handleMaterialSelected
            };

            console.log('[DEBUG] Setting materialDialogData:', JSON.parse(JSON.stringify(this.materialDialogData)));

            // It seems materialDialogCallback was not being used as intended.
            // The @select event on <material-dialog> should directly call handleMaterialSelected.
            // this.materialDialogCallback = callback; // Removing this as it might cause confusion

            this.materialDialogVisible = true;
        },
        // ... existing code ...
        // 获取模块默认颜色
        getModuleColor(type) {
            // 根据模块类型返回默认的背景颜色
            const colorMap = {
                'intro': '#409EFF',
                'live': '#F56C6C',
                'news': '#67C23A',
                'images': '#909399',
                'videos': '#E6A23C',
                'documents': '#409EFF',
                'partners': '#909399',
                'profile': '#1890FF',
                'speakers': '#409EFF',
                'schedule': '#67C23A',
                'register': '#F56C6C',
                'blank': '#909399',
                'custom': '#409EFF',
                'internal': '#409EFF',
                'external': '#67C23A',
                'none': '#909399'
            };

            return colorMap[type] || '#409EFF';
        },
        // 富文本内容变化处理
        handleRichTextChange(content) {
            // Debugging: log content changes
            console.log('富文本内容变更:', content);
            console.log('富文本内容长度:', content ? content.length : 0);

            // Update the local content
            this.currentModule.content = content;
        },
        addModule(type) {
            const id = 'module_' + new Date().getTime() + '_' + Math.floor(Math.random() * 1000);

            // 根据类型创建不同的模块初始化配置
            const newModule = {
                id,
                title: this.getModuleTypeTitle(type),
                icon: this.getModuleTypeIcon(type),
                linkType: type,
                backgroundColor: '#ffffff',
                fontColor: '#333333',
                requiresRegistration: false // 默认不需要报名后进入
            };

            // 针对不同类型的模块，添加特定配置
            if (type === 'intro') {
                newModule.content = ''; // 确保初始化富文本内容为空字符串
            } else if (type === 'live') {
                newModule.liveConfig = {
                    dataSource: 'existing',
                    liveList: [],
                    selectedLiveIds: [],
                    style: 'scroll',
                    max: '2'
                };
            }

            // 将新模块添加到列表中
            this.moduleList.push(newModule);

            // 通知父组件更新
            this.$emit('input', this.moduleList);

            // 立即打开编辑对话框
            this.currentIndex = this.moduleList.length - 1;
            this.currentModule = JSON.parse(JSON.stringify(newModule));
            this.iconType = this.isImageUrl(this.currentModule.icon) ? 'upload' : 'class';
            this.dialogVisible = true;
        },
        // 当修改linkType时，处理不同类型的模块
        handleLinkTypeChange(value) {
            console.log('修改链接类型为:', value);

            // 如果是内容类型，确保content字段存在
            if (value === 'intro' && !this.currentModule.content) {
                this.currentModule.content = '';

                // 使用定时器延迟触发富文本编辑器刷新
                this.$nextTick(() => {
                    setTimeout(() => {
                        richTextEventBus.$emit('dialog-opened');
                    }, 300);
                });
            }
        },
        // 初始化嘉宾配置
        initializeSpeakersConfig() {
            if (!this.currentModule.speakersConfig) {
                this.$set(this.currentModule, 'speakersConfig', {
                    dataSource: 'existing',
                    selectedGuestIds: [],
                    guestList: [],
                    archiveId: ''
                });
            }
        },

        // 处理图片URL
        processImageUrl(url) {
            if (!url) return '';

            // 如果是完整URL则直接返回
            if (url.startsWith('http://') || url.startsWith('https://')) {
                return url;
            }

            // 如果是相对路径，需要添加基础URL
            // 根据实际环境配置获取正确的API基础URL
            const baseUrl = process.env.VUE_APP_BASE_API || '';
            return `${baseUrl}${url}`;
        },
        // 选择嘉宾数据
        selectGuestData() {
            if (!this.currentModule || !this.currentModule.speakersConfig) {
                this.initializeSpeakersConfig();
            }

            // 确保selectedGuestIds已初始化
            if (!this.currentModule.speakersConfig.selectedGuestIds) {
                this.currentModule.speakersConfig.selectedGuestIds = [];
            }

            // 确保guestList已初始化
            if (!this.currentModule.speakersConfig.guestList) {
                this.currentModule.speakersConfig.guestList = [];
            }

            // 打开嘉宾选择对话框
            this.guestSelectDialogVisible = true;
        },

        // 处理嘉宾选择
        handleGuestSelection(selectedGuests) {
            console.log('选中的嘉宾数据:', JSON.stringify(selectedGuests));

            // 保存选中的嘉宾数据
            this.selectedGuestData = selectedGuests;
        },

        // 确认嘉宾选择
        confirmGuestSelection() {
            if (!this.currentModule.speakersConfig) {
                this.initializeSpeakersConfig();
            }

            // 确保数据源设置为从嘉宾管理选择
            this.currentModule.speakersConfig.dataSource = 'existing';

            if (this.selectedGuestData && this.selectedGuestData.length > 0) {
                console.log('开始处理选择的嘉宾数据:', this.selectedGuestData);

                // 将选中的嘉宾数据转换为组件需要的格式
                const newGuestList = this.selectedGuestData.map(guest => {
                    const item = {
                        id: guest.id,
                        name: guest.name,
                        avatar: this.processImageUrl(guest.avatar),
                        company: guest.company,
                        position: guest.position,
                        bio: guest.bio,
                        email: guest.email,
                        phone: guest.phone,
                        category: guest.category
                    };

                    return item;
                });

                // 获取现有的嘉宾ID列表
                const existingIds = this.currentModule.speakersConfig.selectedGuestIds || [];

                // 过滤掉已存在的嘉宾，只添加新的
                const newGuests = newGuestList.filter(guest => !existingIds.includes(guest.id));

                // 追加新的嘉宾到列表中
                this.currentModule.speakersConfig.guestList = [
                    ...(this.currentModule.speakersConfig.guestList || []),
                    ...newGuests
                ];

                // 更新selectedGuestIds，添加新的ID
                this.currentModule.speakersConfig.selectedGuestIds = [
                    ...existingIds,
                    ...newGuests.map(item => item.id)
                ];
            }

            this.guestSelectDialogVisible = false;
        },

        // 删除嘉宾项目
        removeGuestItem(index) {
            const item = this.currentModule.speakersConfig.guestList[index];
            this.currentModule.speakersConfig.guestList.splice(index, 1);
            // 同时从selectedGuestIds中移除
            const idIndex = this.currentModule.speakersConfig.selectedGuestIds.indexOf(item.id);
            if (idIndex > -1) {
                this.currentModule.speakersConfig.selectedGuestIds.splice(idIndex, 1);
            }
        },

        // 选择嘉宾分类
        selectGuestCategory() {
            if (!this.currentModule || !this.currentModule.speakersConfig) {
                this.initializeSpeakersConfig();
            }

            // 确保tabs已初始化
            if (!this.currentModule.speakersConfig.tabs) {
                this.currentModule.speakersConfig.tabs = [];
            }

            // 打开分组选择对话框
            this.guestCategoryDialogVisible = true;

            // 在下一个事件循环中确保组件已经挂载
            this.$nextTick(() => {
                // 预设选中的分组 - 使用扁平结构的分类数据
                if (this.currentModule.speakersConfig.tabs && this.currentModule.speakersConfig.tabs.length > 0) {
                    // 只传递简单的ID和名称结构，不带子分类
                    const selectedGroups = this.currentModule.speakersConfig.tabs.map(category => ({
                        _id: category._id,
                        name: category.name
                    }));

                    // 如果组件已经挂载并有方法可用，则设置预选项
                    const typeListComponent = this.$refs.guestTypeListRef;
                    if (typeListComponent && typeof typeListComponent.selectItems === 'function') {
                        typeListComponent.selectItems(selectedGroups);
                    }
                }
            });
        },

        // 确认嘉宾分组选择
        confirmGuestCategorySelection() {
            if (!this.currentModule.speakersConfig) {
                this.initializeSpeakersConfig();
            }

            // 获取GuestTypeList组件选中的分组
            const typeListComponent = this.$refs.guestTypeListRef;
            if (typeListComponent && typeof typeListComponent.getCheckedList === 'function') {
                const selectedGroups = typeListComponent.getCheckedList();

                if (Array.isArray(selectedGroups)) {
                    // 更新当前模块的分组列表 - 仅存储分类ID和名称，不包含子分类
                    this.currentModule.speakersConfig.tabs = selectedGroups.map(group => ({
                        _id: group._id,
                        name: group.name
                    }));

                    console.log('已选择嘉宾分组:', {
                        count: selectedGroups.length,
                        groups: this.currentModule.speakersConfig.tabs
                    });
                }
            }

            this.guestCategoryDialogVisible = false;
        },
        // 初始化日程配置
        initializeScheduleConfig() {
            if (!this.currentModule.scheduleConfig) {
                this.$set(this.currentModule, 'scheduleConfig', {
                    viewMode: 'matrix',
                    archiveId: '',
                    autoRefresh: true,
                    emptyText: '暂无日程安排'
                });
            }
            // 获取归档列表
            this.getArchiveOptions();
        },

        // 获取归档选项
        async getArchiveOptions() {
            try {
                const res = await getArchiveList({ pageSize: 100 });

                if (res && res.data) {
                    // 处理不同的返回数据结构
                    if (Array.isArray(res.data)) {
                        this.archiveOptions = res.data;
                    } else if (res.data.records) {
                        this.archiveOptions = res.data.records;
                    } else {
                        this.archiveOptions = [];
                    }
                    console.log('获取归档选项成功:', this.archiveOptions);
                } else {
                    console.error('获取归档列表失败:', res);
                    this.$message.error('获取归档列表失败');
                    this.archiveOptions = [];
                }
            } catch (error) {
                console.error('获取归档列表出错:', error);
                this.$message.error('获取归档列表失败');
                this.archiveOptions = [];
            }
        },

        // 获取归档名称
        getArchiveName(archiveId) {
            const archive = this.archiveOptions.find(item => item._id === archiveId);
            return archive ? archive.name : '未知归档';
        },

        // 处理归档变更
        handleArchiveChange() {
            console.log('选择归档:', this.currentModule.scheduleConfig.archiveId);
        },

        // 处理图标类型切换
        handleIconTypeChange(type) {
            this.iconType = type;
            if (type === 'class') {
                this.currentModule.icon = '';
            }
        },

        // 选择模块形状
        selectShape(shape) {
            // 设置当前模块的形状
            this.$set(this.currentModule, 'shape', shape);
        },

        // 其他方法

        // 图片上传成功处理
        handleImageSuccess(res, field) {
            try {
                console.log('图片上传成功:', res);

                // 检查返回的数据结构
                if (res.data) {
                    // 直接使用返回的URL，不检查status字段
                    this.$set(this.currentModule, field, res.data);
                    this.$message.success('图片上传成功');
                } else if (res.errorCode === '00000' && res.data) {
                    // 备用方案：检查errorCode字段
                    this.$set(this.currentModule, field, res.data);
                    this.$message.success('图片上传成功');
                } else {
                    this.$message.error('图片上传失败: ' + (res.message || '未知错误'));
                    console.error('图片上传响应异常:', res);
                }
            } catch (error) {
                console.error('处理图片上传响应时出错:', error);
                this.$message.error('图片上传处理失败');
            }
        },

        // 图片上传前检查
        beforeImageUpload(file) {
            const isImage = file.type.startsWith('image/');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isImage) {
                this.$message.error('只能上传图片文件!');
                return false;
            }

            if (!isLt2M) {
                this.$message.error('图片大小不能超过 2MB!');
                return false;
            }

            return true;
        },

        // 上传错误处理
        handleUploadError(err) {
            console.error('图片上传出错:', err);
            this.$message.error('图片上传失败，请重试');
        },
        // 自定义上传方法
        customUpload(options) {
            const { file, onSuccess, onError } = options;

            // 创建FormData对象
            const formData = new FormData();
            formData.append('file', file);

            // 显示上传中提示
            const loading = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            // 发送上传请求
            fetch('/api/upload', {
                method: 'POST',
                body: formData,
                headers: {
                    // 不设置Content-Type，让浏览器自动设置包含boundary的multipart/form-data
                    // 'Content-Type': 'multipart/form-data',
                    'Authorization': localStorage.getItem('token') || ''
                }
            })
                .then(response => response.json())
                .then(result => {
                    loading.close();
                    console.log('上传结果:', result);

                    // 处理成功响应
                    if (result.data) {
                        this.$set(this.currentModule, 'buttonImage', result.data);
                        this.$message.success('图片上传成功');
                        onSuccess(result);
                    } else {
                        this.$message.error('上传失败: ' + (result.message || '未知错误'));
                        onError(new Error(result.message || '上传失败'));
                    }
                })
                .catch(error => {
                    loading.close();
                    console.error('上传请求失败:', error);
                    this.$message.error('上传失败: ' + error.message);
                    onError(error);
                });
        },
        handleImageLinkTypeChange(item) {
            if (item.linkTargetType === 'external') {
                item.internalPageId = null;
                // item.linkUrl = ''; // 根据需求决定是否清空之前的外部链接
            } else if (item.linkTargetType === 'internal') {
                item.linkUrl = ''; // 清空外部链接
            }
        },

        handleInternalPageSelect(item, pageId) {
            if (pageId) {
                item.linkUrl = `internal://${pageId}`; // 标记为内部链接
            } else {
                item.linkUrl = ''; // 如果取消选择，则清空
            }
            item.internalPageId = pageId; // 更新 internalPageId 以保持下拉框状态
        },

        // // 选择图片 - 当通过素材中心选择图片后，需要初始化新添加图片的链接相关字段
        // handleMaterialSelected(selectedMaterials) {
        //   // ... existing code ...
        //       // 确保新选择的图片有 linkTargetType 和 internalPageId
        //       const newImages = selectedMaterials.map(material => ({
        //         id: material._id || material.id, // 确保有id
        //         url: material.url || material.content,
        //         title: material.title || '新图片',
        //         publishTime: material.publishTime || new Date().toISOString(),
        //         linkUrl: '', // 默认链接为空
        //         linkTargetType: 'external', // 默认链接类型为外部
        //         internalPageId: null // 默认无内部页面选择
        //       }));

        //       // 获取现有的图片ID列表
        //       const existingIds = this.currentModule.imagesConfig.selectedImageIds || [];

        //       // ... existing code ...
        //       // 更新selectedImageIds，添加新的ID
        //       this.currentModule.imagesConfig.selectedImageIds = [
        //         ...existingIds,
        //         ...newImages.map(img => img.id)
        //       ];

        //       console.log('已追加图片数据:', {
        //         newCount: newImages.length,
        //         totalCount: this.currentModule.imagesConfig.imageList.length,
        //         selectedIds: this.currentModule.imagesConfig.selectedImageIds,
        //         dataSource: this.currentModule.imagesConfig.dataSource,
        //         images: this.currentModule.imagesConfig.imageList
        //       });
        // },
    }
};
</script>
<!-- 作用域样式 -->
<style lang="scss" scoped>
.schema-module-editor {
    width: 100%;
    padding: 20px;

    .module-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        .header-title {
            font-weight: 500;
            font-size: 14px;
            color: #333;
        }
    }

    .modules-list {
        margin-top: 15px;

        .module-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 15px;
            background: #fff;
            border: 1px solid #ebeef5;
            border-radius: 4px;
            margin-bottom: 10px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
                border-color: #e6e6e6;
            }

            .module-content {
                display: flex;
                align-items: center;
                flex: 1;
                min-width: 0;
                /* 防止内容溢出 */

                .module-icon {
                    width: 40px;
                    height: 40px;
                    margin-right: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                    background: #f5f7fa;
                    flex-shrink: 0;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }

                    i {
                        font-size: 20px;
                        color: #409EFF;
                    }
                }

                .module-info {
                    flex: 1;
                    min-width: 0;

                    .module-title {
                        font-size: 14px;
                        font-weight: 500;
                        color: #303133;
                        margin-bottom: 4px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .module-subtitle {
                        font-size: 12px;
                        color: #909399;
                        margin-bottom: 4px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .module-type {
                        font-size: 12px;
                        color: #409EFF;
                        background: #ecf5ff;
                        padding: 2px 6px;
                        border-radius: 2px;
                        display: inline-block;
                    }
                }
            }

            .module-actions {
                display: flex;
                align-items: center;

                .drag-handle {
                    margin-right: 10px;
                    font-size: 18px;
                    cursor: move;
                    color: #909399;
                    transition: color 0.3s;

                    &:hover {
                        color: #409EFF;
                    }
                }
            }
        }

        .ghost-module {
            opacity: 0.5;
            background: #d9ecff;
            border: 1px dashed #409EFF;
        }
    }

    .empty-tip {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 30px 0;
        color: #909399;

        i {
            font-size: 40px;
            margin-bottom: 10px;
        }
    }

    .form-tip {
        font-size: 12px;
        color: #909399;
        line-height: 1.4;
        margin-top: 4px;
    }

    .selected-categories {
        margin-top: 8px;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .el-tag {
            margin-right: 5px;
            margin-bottom: 5px;
        }
    }
}

.archive-info {
    margin-top: 10px;
    padding: 8px 12px;
    background-color: #f5f7fa;
    border-radius: 4px;

    .archive-name {
        font-size: 13px;
        color: #606266;
    }
}

/* 形状选择器样式 */
.shape-selector {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 10px;
}

.shape-item {
    width: 110px;
    text-align: center;
    cursor: pointer;
    padding: 15px 10px;
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    transition: all 0.3s;
}

.shape-item:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-color: #409EFF;
}

.shape-item.active {
    border-color: #409EFF;
    background-color: #F0F9FF;
}

.shape-preview {
    margin: 0 auto 10px;
    background-color: #F5F7FA;
    border: 1px solid #DCDFE6;
    position: relative;
    width: 90px;
    height: 68px;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 网格背景 */
.shape-preview::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        linear-gradient(to right, #DCDFE6 1px, transparent 1px),
        linear-gradient(to bottom, #DCDFE6 1px, transparent 1px);
    background-size: 30px 34px;
    opacity: 0.5;
}

/* 不同形状的样式 */
.shape-preview.shape1 .shape-block {
    position: absolute;
    width: 45px;
    height: 34px;
    background-color: #409EFF;
    border-radius: 4px;
    top: 0;
    left: 0;
}

.shape-preview.shape2 .shape-block {
    position: absolute;
    width: 30px;
    height: 34px;
    background-color: #409EFF;
    border-radius: 4px;
    top: 0;
    left: 0;
}

.shape-preview.shape3 .shape-block {
    position: absolute;
    width: 45px;
    height: 68px;
    background-color: #409EFF;
    border-radius: 4px;
    top: 0;
    left: 0;
}

.shape-preview.shape4 .shape-block {
    position: absolute;
    width: 90px;
    height: 34px;
    background-color: #409EFF;
    border-radius: 4px;
    top: 0;
    left: 0;
}

.shape-preview.shape5 .shape-block {
    position: absolute;
    width: 60px;
    height: 34px;
    background-color: #409EFF;
    border-radius: 4px;
    top: 0;
    left: 0;
}

.shape-name {
    font-size: 12px;
    color: #606266;
    margin-top: 5px;
    white-space: nowrap;
}

.upload-preview {
    position: relative;
    width: 160px;
    height: 80px;
    background-color: #f5f7fa;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 10px;

    .preview-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        max-width: 100%;
        max-height: 80px;
    }

    .upload-actions {
        position: absolute;
        top: 5px;
        right: 5px;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        padding: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: opacity 0.3s;
    }

    &:hover .upload-actions {
        opacity: 1;
    }
}

.el-upload-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 80px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    background-color: #fafafa;
    transition: border-color 0.3s;
    cursor: pointer;
    padding: 0;
    box-sizing: border-box;
    overflow: hidden;

    &:hover {
        border-color: #409EFF;
    }

    .upload-btn-inner {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #8c939d;
        font-size: 14px;

        i {
            font-size: 28px;
            margin-bottom: 8px;
        }

        span {
            font-size: 14px;
            line-height: 1.2;
        }
    }
}
</style>
<!-- 全局样式 -->
<style lang="scss">
/* 确保删除按钮样式能覆盖Element UI的默认样式 */
#module-delete-button.module-delete-btn.el-button--danger.el-button--mini {
    padding: 7px 15px !important;
    font-size: 12px !important;
    margin: 0 !important;
    border-color: #F56C6C !important;
    color: #F56C6C !important;
    font-weight: bold !important;
}

#module-delete-button.module-delete-btn.el-button--danger.el-button--mini:hover,
#module-delete-button.module-delete-btn.el-button--danger.el-button--mini:focus {
    background-color: #F56C6C !important;
    color: #fff !important;
    border-color: #F56C6C !important;
}

/* 限制图片预览尺寸 - 针对直播、新闻和图片模块 */
.schema-module-editor .selected-items-container .item-preview-image {
    width: 100% !important;
    height: 120px !important;
    overflow: hidden !important;
    border-radius: 4px !important;
    margin-bottom: 8px !important;
    background-color: #F5F7FA !important;
    position: relative !important;
    max-width: 100% !important;
}

.schema-module-editor .selected-items-container .item-preview-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    object-position: center center !important;
    max-width: 100% !important;
    max-height: 120px !important;
}

.schema-module-editor .selected-items-container .item-preview-image:hover .delete-btn {
    opacity: 1 !important;
}

.schema-module-editor .selected-items-container .delete-btn {
    position: absolute !important;
    top: 5px !important;
    right: 5px !important;
    z-index: 10 !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
    border: none !important;
    padding: 4px !important;
    color: #fff !important;
    opacity: 0 !important;
    transition: opacity 0.3s ease !important;
}

.schema-module-editor .selected-items-container .item-info {
    width: 100% !important;
    overflow: hidden !important;
}

.schema-module-editor .selected-items-container .item-title {
    font-size: 13px !important;
    line-height: 1.4 !important;
    font-weight: 500 !important;
    margin-bottom: 8px !important;
    height: 36px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    word-break: break-word !important;
}

.schema-module-editor .selected-items-container .item-meta {
    font-size: 12px !important;
    color: #909399 !important;
}

/* 确保所有图片容器的父元素也有尺寸限制 */
.schema-module-editor .selected-items-container {
    width: 100% !important;
    max-width: 100% !important;
    overflow: hidden !important;
}

.schema-module-editor .selected-items-container .selected-items-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 15px !important;
    width: 100% !important;
    margin-top: 10px !important;
    max-width: 100% !important;
    overflow: hidden !important;
}

/* 确保每个项目都有固定宽度 */
.schema-module-editor .selected-items-container .selected-item {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 10px !important;
    box-sizing: border-box !important;
    position: relative !important;
    border: 1px solid #EBEEF5 !important;
    border-radius: 4px !important;
    transition: all 0.3s ease !important;
    overflow: hidden !important;
}

/* 添加悬停效果 */
.schema-module-editor .selected-items-container .selected-item:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
    border-color: #DCDFE6 !important;
}
</style>